import { useVeltClient, VeltSidebarButton, VeltCommentTool, VeltHuddleTool, VeltPresence } from '@veltdev/react';
import { useEffect, useState } from 'react';


function Footer(){
  return (
    <div className='velt-footer'>
      <div style={{display:"flex", margin:"4px", justifyContent:"flex-end", alignItems:"center"}}>
        <VeltPresence/>
        <VeltCommentTool/>
        <VeltHuddleTool/>
        <div style={{margin:"1px"}}>
          <VeltSidebarButton/>
        </div>
      </div>

    </div>
  )
}

export default function YourDocument() {

  // Get the Velt client
  const { client } = useVeltClient();

  useEffect(() => {
    if (client) {
      // Set a document ID
      client.setDocumentId('strikingly-demo-id');
    }
  }, [client]);

  return (
    <>
    <Footer/>
  <meta charSet="utf-8" />
  <meta
    name="description"
    content="Habitat for Humanity is a nonprofit organization that helps people in your community and around the world build or improve a place they can call home. Donate, volunteer and raise your voice in support of decent and affordable housing."
  />
  <meta property="fb:pages" content={19774119425} />
  <meta name="Generator" content="Drupal 10 (https://www.drupal.org)" />
  <meta name="MobileOptimized" content="width" />
  <meta name="HandheldFriendly" content="true" />
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1, user-scalable=no"
  />
  <title>Habitat for Humanity</title>
  {/* Facebook Pixel Code */}
  <noscript>
    &lt;img height="1" width="1" style="display:none"
    src="https://www.facebook.com/tr?id=1909185845978051&amp;ev=PageView
    &amp;noscript=1"/&gt;
  </noscript>
  {/* DO NOT MODIFY */}
  {/* End Facebook Pixel Code */}
  <noscript>
    &lt;iframe src="//www.googletagmanager.com/ns.html?id=GTM-NXHV9Q8"
    height="0" width="0"&gt;&lt;/iframe&gt;
  </noscript>
  <a href="#main-content" className="visually-hidden focusable">
    Skip to main content
  </a>
  <div className="dialog-off-canvas-main-canvas" data-off-canvas-main-canvas="">
    <div className="page">
      <header className="header">
        <div className="header__content">
          <a
            href="/"
            rel="home"
            className="header__logo site-logo__link active"
          >
            {" "}
            <svg
              className="branding"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 120 40"
              width={120}
              height={40}
            >
              <title>Logo</title>
              <path d="M14.9,17.06a2.14,2.14,0,1,1,2.29,2,2.14,2.14,0,0,1-2.29-2h0Z" />
              <path d="M40,17.06a2.14,2.14,0,1,0-2.29,2,2.14,2.14,0,0,0,2.29-2h0Z" />
              <path d="M47.06,20.41c-0.25-.93-1.53-1.07-2.66-0.78a22.2,22.2,0,0,1-6.75.89c-2-.14-3.91-1.79-5.12-2.92,1.2-1.38,2.74-2.86,3.09-3.27a1.57,1.57,0,0,0,.17-2c-0.43-.43-1.19-0.17-2,0.34s-3.66,3.43-6.42,3.43-5.75-2.92-6.52-3.43a2,2,0,0,0-2.3,0c-0.43.43,0,1,.51,1.62,0.36,0.42,2,2,3.17,3.36-1.21,1.12-3.1,2.69-5,2.83a22.19,22.19,0,0,1-6.75-.89c-1.13-.29-2.41-0.15-2.66.78a1.72,1.72,0,0,0,1,1.65c0.66,0.43,4.07,1.09,5,2.56s1.11,12.82,2,13.2a3.36,3.36,0,0,0,2.41,0c0.87-.44,2.33-12.82,3.06-14.41a19.35,19.35,0,0,1,2.35-3.3c0.79,3.7,1.65,17.48,2.48,17.76a4.44,4.44,0,0,0,2.38,0c0.82-.35,1.72-14.5,2.52-17.93a20.35,20.35,0,0,1,2.49,3.46c0.74,1.59,2.2,14,3.06,14.41a3.37,3.37,0,0,0,2.41,0c0.89-.38,1-11.73,2-13.2s4.37-2.13,5-2.56a1.72,1.72,0,0,0,1-1.65h0Z" />
              <path d="M25.31,12.52a2.14,2.14,0,1,1,2.14,2.14,2.14,2.14,0,0,1-2.14-2.14h0Z" />
              <path d="M47.49,12.67c1,1.65-1.14,2.27-2.8,1.89-1.39-.32-15.06-7.62-17.11-7.81s-14.33,7.37-15.69,8.1a5.53,5.53,0,0,1-5.59,0C5.7,14.53,1,12.06,0,11.37c1-1,15.23-9.49,16.89-10.31,1.9-1,3-1.46,5.13-.67,1.45,0.54,25,11.6,25.47,12.28h0Z" />
              <path d="M5.39,23.27a28.24,28.24,0,0,1,4,1.67c2.39,1.23,2.52,2.46,2.79,4.45s0.54,6.08.58,7.58a53.62,53.62,0,0,1-5.86-4.52c-0.72-.63-1.54-1.08-1.53-2.05,0-.37-0.17-6.22,0-7.14h0Z" />
              <path d="M117.56,29.24A1.79,1.79,0,1,1,115.75,31a1.79,1.79,0,0,1,1.81-1.79h0Zm0,3.31A1.52,1.52,0,1,0,116.08,31a1.47,1.47,0,0,0,1.48,1.53h0Zm-0.39-.49h-0.3V30h0.8a0.59,0.59,0,0,1,.73.59,0.55,0.55,0,0,1-.55.58l0.6,0.92h-0.33l-0.57-.91h-0.39v0.91h0Zm0-1.16h0.49c0.33,0,.43-0.12.43-0.35a0.32,0.32,0,0,0-.37-0.32h-0.56V30.9h0Z" />
              <path d="M57,11.65c-0.09,1.05-.11,2.27-0.11,3.58V17.7c0.47,0,.94,0,1.63,0s1.16,0,1.63,0V15.23c0-1.31,0-2.53-.11-3.58h4.06a75.66,75.66,0,0,0-.21,7.66A75.67,75.67,0,0,0,64.09,27H60c0.09-1.05.11-2.28,0.11-3.58V20.25c-0.47,0-.94,0-1.63,0s-1.16,0-1.63,0v3.13c0,1.31,0,2.53.11,3.58H52.93a75.42,75.42,0,0,0,.21-7.66,75.41,75.41,0,0,0-.21-7.66H57Z" />
              <path d="M66,16.07a20.71,20.71,0,0,1,2.25-.17c4.44,0,5.79,1.74,5.79,4.61v2.68A10.26,10.26,0,0,0,74.56,27H71.15a2.13,2.13,0,0,1-.37-0.67,4,4,0,0,1-2.4.84,3.22,3.22,0,0,1-3.43-3.24c0-2,1.57-3.31,3.61-4l1.78-.58A1.39,1.39,0,0,0,68.81,18,5.27,5.27,0,0,0,66,19.07v-3h0Zm4.66,5.32a2.49,2.49,0,0,0-2.19,2.25A1.21,1.21,0,0,0,69.58,25a1.42,1.42,0,0,0,1-.47V21.39h0Z" />
              <path d="M79.34,11.65V16.5a4.24,4.24,0,0,1,2.08-.6c2,0,3.95,1.5,3.95,5.41,0,3-1.65,5.92-4.7,5.92a4.45,4.45,0,0,1-2.77-1.07l-1.2,1-1-.62a31.83,31.83,0,0,0,.19-4.38V16c0-.79,0-1.67-0.22-4.38h3.69Zm0,12.32a0.93,0.93,0,0,0,.92,1.12c0.88,0,1.5-.9,1.5-3.45,0-1.82-.47-3.39-1.55-3.39a0.81,0.81,0,0,0-.88.88V24h0Z" />
              <path d="M88.43,11.5a1.93,1.93,0,1,1-1.93,1.93,1.92,1.92,0,0,1,1.93-1.93h0Zm1.78,4.66c0,1.11,0,2.75,0,5.06A43.3,43.3,0,0,0,90.36,27H86.49a31.92,31.92,0,0,0,.19-4.38V20.53a31.9,31.9,0,0,0-.19-4.38h3.71Z" />
              <path d="M96.13,12.87c0,0.66-.07,1.93-0.07,3.28h1.61v2.06H96.07v5.41A1.12,1.12,0,0,0,97.25,25a3.63,3.63,0,0,0,.45,0v1.93a6.81,6.81,0,0,1-2.17.32,2.88,2.88,0,0,1-2.32-1,4,4,0,0,1-.62-2.53V18.21H91.34V16.15h1.24c0-1.35,0-2.62-.07-3.28h3.61Z" />
              <path d="M99.78,16.07A20.75,20.75,0,0,1,102,15.9c4.44,0,5.79,1.74,5.79,4.61v2.68a10.27,10.27,0,0,0,.56,3.78H105a2.06,2.06,0,0,1-.36-0.67,4,4,0,0,1-2.4.84,3.22,3.22,0,0,1-3.43-3.24c0-2,1.57-3.31,3.6-4l1.78-.58A1.39,1.39,0,0,0,102.64,18a5.28,5.28,0,0,0-2.86,1.12v-3h0Zm4.66,5.32a2.49,2.49,0,0,0-2.19,2.25A1.21,1.21,0,0,0,103.41,25a1.42,1.42,0,0,0,1-.47V21.39h0Z" />
              <path d="M113.64,12.87c0,0.66-.06,1.93-0.06,3.28h1.61v2.06h-1.61v5.41A1.12,1.12,0,0,0,114.76,25a3.63,3.63,0,0,0,.45,0v1.93a6.81,6.81,0,0,1-2.17.32,2.88,2.88,0,0,1-2.32-1,4,4,0,0,1-.62-2.53V18.21h-1.25V16.15h1.25c0-1.35,0-2.62-.07-3.28h3.61Z" />
              <path d="M56.42,30.7A0.78,0.78,0,0,0,56,30.58a0.71,0.71,0,0,0-.72.77,1.7,1.7,0,0,0,.12.58h0.87V33H55.35v2.37a17.39,17.39,0,0,0,.1,2.37H53.36a17.28,17.28,0,0,0,.1-2.37V33H52.83V31.93h0.64V31.48a1.8,1.8,0,0,1,.66-1.6,2.49,2.49,0,0,1,1.56-.5,2.38,2.38,0,0,1,.73.11V30.7h0Z" />
              <path d="M61.79,34.86a2.74,2.74,0,1,1-5.44,0,2.74,2.74,0,1,1,5.44,0h0Zm-3.37,0c0,1.41.3,1.91,0.65,1.91s0.65-.5.65-1.91S59.42,33,59.07,33s-0.65.5-.65,1.91h0Z" />
              <path d="M64.24,31.93a4.08,4.08,0,0,1,.16.78,1.91,1.91,0,0,1,1.48-.92,0.67,0.67,0,0,1,.26,0v1.55a1.57,1.57,0,0,0-.35,0c-0.88,0-1.27.81-1.27,2.09a17.31,17.31,0,0,0,.1,2.37H62.46a17.19,17.19,0,0,0,.11-2.37V34.3a9.27,9.27,0,0,0-.2-2.37h1.87Z" />
              <path d="M72.33,29.49c0,0.57-.06,1.23-0.06,1.94v1.34l0.88,0,0.88,0V31.43c0-.71,0-1.37-0.06-1.94h2.2a41,41,0,0,0-.12,4.15,41,41,0,0,0,.12,4.15H74c0-.57.06-1.23,0.06-1.94v-1.7c-0.25,0-.51,0-0.88,0s-0.63,0-.88,0v1.7c0,0.71,0,1.37.06,1.94h-2.2a41.17,41.17,0,0,0,.12-4.15,41.16,41.16,0,0,0-.12-4.15h2.2Z" />
              <path d="M80.42,37.79a2.63,2.63,0,0,1-.17-0.52,2,2,0,0,1-1.48.66,1.64,1.64,0,0,1-1.64-1.84V34.3A17,17,0,0,0,77,31.93h2v3.89a0.57,0.57,0,1,0,1.12.12V34.3a17.34,17.34,0,0,0-.1-2.37h2.09A17.18,17.18,0,0,0,82,34.3v1.12a17.19,17.19,0,0,0,.11,2.37h-1.7Z" />
              <path d="M84.84,31.93a2.89,2.89,0,0,1,.18.52,2.28,2.28,0,0,1,1.53-.66,1.57,1.57,0,0,1,1.3.74,2.35,2.35,0,0,1,1.64-.74c1.14,0,1.57.8,1.57,2v1.67a17.51,17.51,0,0,0,.1,2.37H89.07a17.51,17.51,0,0,0,.1-2.37V33.8c0-.41-0.12-0.71-0.48-0.71a0.63,0.63,0,0,0-.62.71v1.62a17.19,17.19,0,0,0,.11,2.37H86.1a17.19,17.19,0,0,0,.11-2.37V33.78c0-.38-0.12-0.69-0.48-0.69a0.62,0.62,0,0,0-.62.62v1.71a17.27,17.27,0,0,0,.1,2.37H83.12a17.35,17.35,0,0,0,.1-2.37V34.3a17.34,17.34,0,0,0-.1-2.37h1.72Z" />
              <path d="M92.29,31.88a11.54,11.54,0,0,1,1.22-.09c2.41,0,3.14.94,3.14,2.5v1.45a5.57,5.57,0,0,0,.3,2H95.11a1.09,1.09,0,0,1-.2-0.36,2.16,2.16,0,0,1-1.3.45,1.75,1.75,0,0,1-1.86-1.76,2.41,2.41,0,0,1,2-2.15l1-.31a0.75,0.75,0,0,0-.83-0.76,2.86,2.86,0,0,0-1.55.61V31.88h0Zm2.52,2.88A1.35,1.35,0,0,0,93.63,36a0.66,0.66,0,0,0,.63.72,0.76,0.76,0,0,0,.56-0.26V34.77h0Z" />
              <path d="M99.19,31.93a2.8,2.8,0,0,1,.17.52,2,2,0,0,1,1.48-.66,1.64,1.64,0,0,1,1.64,1.84v1.79a17.2,17.2,0,0,0,.11,2.37h-2.09a17.19,17.19,0,0,0,.11-2.37v-1.6a0.54,0.54,0,0,0-.5-0.65,0.59,0.59,0,0,0-.62.56v1.7a17.52,17.52,0,0,0,.1,2.37H97.49a17.5,17.5,0,0,0,.1-2.37V34.3a17.5,17.5,0,0,0-.1-2.37h1.7Z" />
              <path d="M104.31,29.41a1,1,0,1,1-1,1,1,1,0,0,1,1-1h0Zm1,2.52c0,0.6,0,1.49,0,2.74a23.42,23.42,0,0,0,.1,3.12h-2.09a17.27,17.27,0,0,0,.1-2.37V34.3a17.26,17.26,0,0,0-.1-2.37h2Z" />
              <path d="M108.59,30.15c0,0.36,0,1,0,1.78h0.87V33h-0.87V36a0.61,0.61,0,0,0,.64.74h0.24v1a3.7,3.7,0,0,1-1.18.17,1.56,1.56,0,0,1-1.25-.56,2.17,2.17,0,0,1-.34-1.37V33H106V31.93h0.67c0-.73,0-1.42,0-1.78h2Z" />
              <path d="M112,31.93a33.43,33.43,0,0,0,.83,3.31h0a27.4,27.4,0,0,0,.68-3.31h1.66a40.54,40.54,0,0,1-2,6.35A2.61,2.61,0,0,1,110.63,40a2.22,2.22,0,0,1-.56-0.06V38.45a1.41,1.41,0,0,0,.65.17,1,1,0,0,0,1-.93,5.32,5.32,0,0,0-.51-1.59A26.18,26.18,0,0,1,110,31.93h2Z" />
            </svg>
          </a>
          <div className="header__menu-search">
            <div className="header__main-menu">
              <nav
                className="dropdown-menu dropdown-menu--main-menu"
                aria-label="Dropdown menu"
                data-collapse-group="single"
              >
                <button className="dropdown-menu__close-all">
                  <span className="dropdown-menu__close-all--icon">
                    <svg
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                      <clipPath id="a">
                        <path d="m0 0h24v24h-24z" />
                      </clipPath>
                      <g clipPath="url(#a)">
                        <path d="m18.38 5.65c3.51 3.52 3.49 9.22-.03 12.73s-9.22 3.49-12.73-.03-3.49-9.22.03-12.73c3.51-3.49 9.18-3.49 12.69 0l.03.03m-1.89 7.93v-2.72h-8.95v2.72h8.96z" />
                      </g>
                    </svg>
                  </span>
                  CLOSE ALL
                </button>
                <ul className="dropdown-menu__menu">
                  <li
                    className="dropdown-menu__menu-item"
                    data-is-collapsible=""
                  >
                    <button
                      className="dropdown-menu__menu-button"
                      data-collapsible-toggle=""
                    >
                      <div className="dropdown-menu__menu-button--icon">
                        <svg
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                          <clipPath id="a">
                            <path d="m0 0h24v24h-24z" />
                          </clipPath>
                          <g clipPath="url(#a)">
                            <path
                              className="plusminus__horizontal"
                              d="m3.47 10.5h17.06c.23 0 .43.15.47.37v2.25c-.04.22-.24.38-.47.37h-17.06c-.23 0-.43-.15-.47-.37v-2.06c-.04-.27.16-.52.43-.56z"
                            />
                            <path
                              className="plusminus__vertical"
                              d="m13.5 3.47v17.06c0 .23-.15.43-.37.47h-2.25c-.22-.04-.38-.24-.37-.47v-17.06c0-.23.15-.43.37-.47h2.06c.27-.04.52.16.56.43z"
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="dropdown-menu__menu-button--text">
                        Volunteer
                      </div>
                    </button>
                    <div
                      className="dropdown-menu__panel"
                      data-collapsible-content=""
                    >
                      <div
                        className="dropdown-menu__panel-wrapper"
                        data-collapsible-content-wrapper=""
                      >
                        <div className="dropdown-menu__panel-header">
                          <a
                            href="/volunteer"
                            className="dropdown-menu__panel-header--link"
                            tabIndex={-1}
                          >
                            <h2 className="dropdown-menu__panel-header--text">
                              Volunteer
                            </h2>
                          </a>
                        </div>
                        <ul className="dropdown-menu__submenu">
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/volunteer/near-you"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Near you
                            </a>
                            <ul className="dropdown-menu__tertiarymenu">
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/near-you/find-your-local-habitat"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Find your local Habitat
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/near-you/women-build"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Women Build
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/near-you/home-preservation"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Home Preservation
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/near-you/veterans-build"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Veterans Build
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/near-you/youth-programs"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Youth Programs
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/volunteer/travel-and-build"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Travel &amp; build
                            </a>
                            <ul className="dropdown-menu__tertiarymenu">
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/travel-and-build/global-village"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Global Village
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/travel-and-build/rv-care-a-vanners"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  RV Care-A-Vanners
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/travel-and-build/collegiate-challenge"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Collegiate Challenge
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/travel-and-build/habitat-thrivent-worldwide"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Habitat and Thrivent
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/volunteer/long-term-opportunities"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Long-term service
                            </a>
                            <ul className="dropdown-menu__tertiarymenu">
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/long-term-opportunities/international"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  International
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/long-term-opportunities/united-states"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  United States
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/long-term-opportunities/americorps"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  AmeriCorps
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/long-term-opportunities/disaster-corps"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Disaster Corps
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/volunteer/group-opportunities"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Group opportunities
                            </a>
                            <ul className="dropdown-menu__tertiarymenu">
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/group-opportunities/business-partners"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Business partners
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/group-opportunities/faith-partners"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Faith partners
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/group-opportunities/community-organizations"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Community organizations
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/volunteer/build-events"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Build events
                            </a>
                            <ul className="dropdown-menu__tertiarymenu">
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/carter-work-project"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Carter Work Project
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/long-term-opportunities/americorps/build-a-thon"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  AmeriCorps Build-a-Thon
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/volunteer/build-events/world-habitat-day"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  World Habitat Day
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li
                    className="dropdown-menu__menu-item"
                    data-is-collapsible=""
                  >
                    <button
                      className="dropdown-menu__menu-button"
                      data-collapsible-toggle=""
                    >
                      <div className="dropdown-menu__menu-button--icon">
                        <svg
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                          <clipPath id="a">
                            <path d="m0 0h24v24h-24z" />
                          </clipPath>
                          <g clipPath="url(#a)">
                            <path
                              className="plusminus__horizontal"
                              d="m3.47 10.5h17.06c.23 0 .43.15.47.37v2.25c-.04.22-.24.38-.47.37h-17.06c-.23 0-.43-.15-.47-.37v-2.06c-.04-.27.16-.52.43-.56z"
                            />
                            <path
                              className="plusminus__vertical"
                              d="m13.5 3.47v17.06c0 .23-.15.43-.37.47h-2.25c-.22-.04-.38-.24-.37-.47v-17.06c0-.23.15-.43.37-.47h2.06c.27-.04.52.16.56.43z"
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="dropdown-menu__menu-button--text">
                        Advocate
                      </div>
                    </button>
                    <div
                      className="dropdown-menu__panel"
                      data-collapsible-content=""
                    >
                      <div
                        className="dropdown-menu__panel-wrapper"
                        data-collapsible-content-wrapper=""
                      >
                        <div className="dropdown-menu__panel-header">
                          <a
                            href="/about/advocacy"
                            className="dropdown-menu__panel-header--link"
                            tabIndex={-1}
                          >
                            <h2 className="dropdown-menu__panel-header--text">
                              Advocate
                            </h2>
                          </a>
                        </div>
                        <ul className="dropdown-menu__submenu">
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/costofhome"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              United States
                            </a>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/home-equals"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              International
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li
                    className="dropdown-menu__menu-item"
                    data-is-collapsible=""
                  >
                    <button
                      className="dropdown-menu__menu-button"
                      data-collapsible-toggle=""
                    >
                      <div className="dropdown-menu__menu-button--icon">
                        <svg
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                          <clipPath id="a">
                            <path d="m0 0h24v24h-24z" />
                          </clipPath>
                          <g clipPath="url(#a)">
                            <path
                              className="plusminus__horizontal"
                              d="m3.47 10.5h17.06c.23 0 .43.15.47.37v2.25c-.04.22-.24.38-.47.37h-17.06c-.23 0-.43-.15-.47-.37v-2.06c-.04-.27.16-.52.43-.56z"
                            />
                            <path
                              className="plusminus__vertical"
                              d="m13.5 3.47v17.06c0 .23-.15.43-.37.47h-2.25c-.22-.04-.38-.24-.37-.47v-17.06c0-.23.15-.43.37-.47h2.06c.27-.04.52.16.56.43z"
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="dropdown-menu__menu-button--text">
                        Support
                      </div>
                    </button>
                    <div
                      className="dropdown-menu__panel"
                      data-collapsible-content=""
                    >
                      <div
                        className="dropdown-menu__panel-wrapper"
                        data-collapsible-content-wrapper=""
                      >
                        <div className="dropdown-menu__panel-header">
                          <a
                            href="https://www.habitat.org/support"
                            className="dropdown-menu__panel-header--link"
                            tabIndex={-1}
                          >
                            <h2 className="dropdown-menu__panel-header--text">
                              Support
                            </h2>
                          </a>
                        </div>
                        <ul className="dropdown-menu__submenu">
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="https://www.habitat.org/donate/?keyword=menu-top"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Donate now
                            </a>
                            <ul className="dropdown-menu__tertiarymenu">
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="https://www.habitat.org/donate/?keyword=menu-one-time"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  One time donations
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/support/monthly-recurring-donation"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Monthly donations
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/support/honor-memorial-gifts"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Honor and memorial gifts
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="https://secure.habitat.org/site/Ecommerce/?store_id=2482&VIEW_HOMEPAGE=true&FOLDER=0&s_subsrc=menu"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Gift catalog
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/support/donate-items"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Donate items
                            </a>
                            <ul className="dropdown-menu__tertiarymenu">
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/restores/donate-goods"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Goods and materials
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/support/donate-your-car"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Donate your car
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/support/partnerships"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Partnerships
                            </a>
                            <ul className="dropdown-menu__tertiarymenu">
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/support/workplace-giving"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Workplace giving
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/support/corporate-giving"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Corporate giving
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/support/gifts-in-kind"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Gifts-in-kind partnerships
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/about/partners/cause-marketing"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Cause marketing
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/support/planned-giving"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Planned giving
                            </a>
                            <ul className="dropdown-menu__tertiarymenu">
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/support/donate-stock"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Stock donations
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/support/donor-advised-funds"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Donor-advised funds
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="https://www.habitat.org/multimedia/case-for-support/"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Case for support
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li
                    className="dropdown-menu__menu-item"
                    data-is-collapsible=""
                  >
                    <button
                      className="dropdown-menu__menu-button"
                      data-collapsible-toggle=""
                    >
                      <div className="dropdown-menu__menu-button--icon">
                        <svg
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                          <clipPath id="a">
                            <path d="m0 0h24v24h-24z" />
                          </clipPath>
                          <g clipPath="url(#a)">
                            <path
                              className="plusminus__horizontal"
                              d="m3.47 10.5h17.06c.23 0 .43.15.47.37v2.25c-.04.22-.24.38-.47.37h-17.06c-.23 0-.43-.15-.47-.37v-2.06c-.04-.27.16-.52.43-.56z"
                            />
                            <path
                              className="plusminus__vertical"
                              d="m13.5 3.47v17.06c0 .23-.15.43-.37.47h-2.25c-.22-.04-.38-.24-.37-.47v-17.06c0-.23.15-.43.37-.47h2.06c.27-.04.52.16.56.43z"
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="dropdown-menu__menu-button--text">
                        Shop
                      </div>
                    </button>
                    <div
                      className="dropdown-menu__panel"
                      data-collapsible-content=""
                    >
                      <div
                        className="dropdown-menu__panel-wrapper"
                        data-collapsible-content-wrapper=""
                      >
                        <div className="dropdown-menu__panel-header">
                          <a
                            href="/shop"
                            className="dropdown-menu__panel-header--link"
                            tabIndex={-1}
                          >
                            <h2 className="dropdown-menu__panel-header--text">
                              Shop
                            </h2>
                          </a>
                        </div>
                        <ul className="dropdown-menu__submenu">
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/restores-3"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Habitat ReStores
                            </a>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="http://www.thehabitatstore.org/"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Habitat-branded merchandise
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li
                    className="dropdown-menu__menu-item"
                    data-is-collapsible=""
                  >
                    <button
                      className="dropdown-menu__menu-button"
                      data-collapsible-toggle=""
                    >
                      <div className="dropdown-menu__menu-button--icon">
                        <svg
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                          <clipPath id="a">
                            <path d="m0 0h24v24h-24z" />
                          </clipPath>
                          <g clipPath="url(#a)">
                            <path
                              className="plusminus__horizontal"
                              d="m3.47 10.5h17.06c.23 0 .43.15.47.37v2.25c-.04.22-.24.38-.47.37h-17.06c-.23 0-.43-.15-.47-.37v-2.06c-.04-.27.16-.52.43-.56z"
                            />
                            <path
                              className="plusminus__vertical"
                              d="m13.5 3.47v17.06c0 .23-.15.43-.37.47h-2.25c-.22-.04-.38-.24-.37-.47v-17.06c0-.23.15-.43.37-.47h2.06c.27-.04.52.16.56.43z"
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="dropdown-menu__menu-button--text">
                        Our work
                      </div>
                    </button>
                    <div
                      className="dropdown-menu__panel"
                      data-collapsible-content=""
                    >
                      <div
                        className="dropdown-menu__panel-wrapper"
                        data-collapsible-content-wrapper=""
                      >
                        <div className="dropdown-menu__panel-header">
                          <a
                            href="/our-work"
                            className="dropdown-menu__panel-header--link"
                            tabIndex={-1}
                          >
                            <h2 className="dropdown-menu__panel-header--text">
                              Our work
                            </h2>
                          </a>
                        </div>
                        <ul className="dropdown-menu__submenu dropdown-menu__submenu--vertical">
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/our-work"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Overview
                            </a>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/our-work/home-construction"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Home construction
                            </a>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/our-work/aging-in-place"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Older adults' home repair
                            </a>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/our-work/neighborhood-revitalization"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Revitalizing communities
                            </a>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/impact/our-work/disaster-response"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Disaster response
                            </a>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/our-work/terwilliger-center-innovation-in-shelter"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Innovation
                            </a>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/our-work/impact"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Impact and stories
                            </a>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/where-we-work"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Where we work
                            </a>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/you-thought-leadership-series"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Live stream events
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li
                    className="dropdown-menu__menu-item"
                    data-is-collapsible=""
                  >
                    <button
                      className="dropdown-menu__menu-button"
                      data-collapsible-toggle=""
                    >
                      <div className="dropdown-menu__menu-button--icon">
                        <svg
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                          <clipPath id="a">
                            <path d="m0 0h24v24h-24z" />
                          </clipPath>
                          <g clipPath="url(#a)">
                            <path
                              className="plusminus__horizontal"
                              d="m3.47 10.5h17.06c.23 0 .43.15.47.37v2.25c-.04.22-.24.38-.47.37h-17.06c-.23 0-.43-.15-.47-.37v-2.06c-.04-.27.16-.52.43-.56z"
                            />
                            <path
                              className="plusminus__vertical"
                              d="m13.5 3.47v17.06c0 .23-.15.43-.37.47h-2.25c-.22-.04-.38-.24-.37-.47v-17.06c0-.23.15-.43.37-.47h2.06c.27-.04.52.16.56.43z"
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="dropdown-menu__menu-button--text">
                        Housing help
                      </div>
                    </button>
                    <div
                      className="dropdown-menu__panel"
                      data-collapsible-content=""
                    >
                      <div
                        className="dropdown-menu__panel-wrapper"
                        data-collapsible-content-wrapper=""
                      >
                        <div className="dropdown-menu__panel-header">
                          <a
                            href="/housing-help"
                            className="dropdown-menu__panel-header--link"
                            tabIndex={-1}
                          >
                            <h2 className="dropdown-menu__panel-header--text">
                              Housing help
                            </h2>
                          </a>
                        </div>
                        <ul className="dropdown-menu__submenu">
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/housing-help/apply"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              How to apply
                            </a>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/housing-help/habitat-homeowners"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Habitat homeowners
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li
                    className="dropdown-menu__menu-item"
                    data-is-collapsible=""
                  >
                    <button
                      className="dropdown-menu__menu-button"
                      data-collapsible-toggle=""
                    >
                      <div className="dropdown-menu__menu-button--icon">
                        <svg
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                          <clipPath id="a">
                            <path d="m0 0h24v24h-24z" />
                          </clipPath>
                          <g clipPath="url(#a)">
                            <path
                              className="plusminus__horizontal"
                              d="m3.47 10.5h17.06c.23 0 .43.15.47.37v2.25c-.04.22-.24.38-.47.37h-17.06c-.23 0-.43-.15-.47-.37v-2.06c-.04-.27.16-.52.43-.56z"
                            />
                            <path
                              className="plusminus__vertical"
                              d="m13.5 3.47v17.06c0 .23-.15.43-.37.47h-2.25c-.22-.04-.38-.24-.37-.47v-17.06c0-.23.15-.43.37-.47h2.06c.27-.04.52.16.56.43z"
                            />
                          </g>
                        </svg>
                      </div>
                      <div className="dropdown-menu__menu-button--text">
                        About
                      </div>
                    </button>
                    <div
                      className="dropdown-menu__panel"
                      data-collapsible-content=""
                    >
                      <div
                        className="dropdown-menu__panel-wrapper"
                        data-collapsible-content-wrapper=""
                      >
                        <div className="dropdown-menu__panel-header">
                          <a
                            href="/about"
                            className="dropdown-menu__panel-header--link"
                            tabIndex={-1}
                          >
                            <h2 className="dropdown-menu__panel-header--text">
                              About
                            </h2>
                          </a>
                        </div>
                        <ul className="dropdown-menu__submenu">
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/about/what-we-do"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              What we do
                            </a>
                            <ul className="dropdown-menu__tertiarymenu">
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/about/faq"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Frequently asked questions
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/about/mission-and-vision"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Mission and vision
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/about/who-we-are"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Who we are
                            </a>
                            <ul className="dropdown-menu__tertiarymenu">
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/about/history"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  History
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/about/habitat-for-humanity-leadership"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Leadership
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/about/partners"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Partners
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/about/resources"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Resources
                            </a>
                            <ul className="dropdown-menu__tertiarymenu">
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/about/annual-reports-990s"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Annual Reports and 990s
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/about/habitat-learns"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Habitat Learns
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/about/state-support-organizations"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  State support organizations
                                </a>
                              </li>
                              <li className="dropdown-menu__tertiarymenu-item">
                                <a
                                  href="/about/raising-concerns"
                                  className="dropdown-menu__tertiarymenu-link"
                                  tabIndex={-1}
                                >
                                  Raising concerns
                                </a>
                              </li>
                            </ul>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/about/careers"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Careers
                            </a>
                          </li>
                          <li className="dropdown-menu__submenu-item">
                            <a
                              href="/newsroom"
                              className="dropdown-menu__submenu-link"
                              tabIndex={-1}
                            >
                              Newsroom
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </nav>
            </div>
            <div
              className="header__search"
              data-collapse-group=""
              data-is-collapsible=""
            >
              <div
                className="header__search-icon"
                data-collapsible-toggle=""
                tabIndex={0}
                aria-expanded="false"
              >
                <svg
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <clipPath id="a">
                    <path d="m0 0h24v24h-24z" />
                  </clipPath>
                  <g clipPath="url(#a)">
                    <path d="m15.2 5.3c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9c2.45 2.46 6.33 2.73 9.1.65l.25.9 4 4 2.1-2.1-4-4-.9-.25c2.06-2.78 1.78-6.64-.65-9.1zm-1.95 7.95c-1.63 1.67-4.31 1.7-5.98.07-.02-.02-.05-.05-.07-.07-1.67-1.67-1.67-4.38 0-6.05s4.38-1.67 6.05 0 1.67 4.38 0 6.05z" />
                  </g>
                </svg>
              </div>
              <div
                className="header__search-search"
                data-collapsible-content=""
                aria-hidden="true"
              >
                <div
                  className="header__search-wrapper"
                  data-collapsible-content-wrapper=""
                >
                  <div className="header-search">
                    <form className="header-search__form" action="/search">
                      <label className="header-search__label" htmlFor="search">
                        Search habitat.org
                      </label>
                      <input
                        className="header-search__input"
                        title="Search"
                        type="search"
                        name="search"
                        defaultValue=""
                        tabIndex={-1}
                      />
                      <button
                        className="header-search__submit"
                        type="submit"
                        tabIndex={-1}
                      >
                        <svg
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                          <clipPath id="a">
                            <path d="m0 0h24v24h-24z" />
                          </clipPath>
                          <g clipPath="url(#a)">
                            <path d="m15.2 5.3c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9c2.45 2.46 6.33 2.73 9.1.65l.25.9 4 4 2.1-2.1-4-4-.9-.25c2.06-2.78 1.78-6.64-.65-9.1zm-1.95 7.95c-1.63 1.67-4.31 1.7-5.98.07-.02-.02-.05-.05-.07-.07-1.67-1.67-1.67-4.38 0-6.05s4.38-1.67 6.05 0 1.67 4.38 0 6.05z" />
                          </g>
                        </svg>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="header__supplementary-nav">
            <nav
              className="donate-menu"
              role="navigation"
              aria-label="Donate Menu"
            >
              <button
                className="donate-cta"
                aria-label="donate toggle button"
                aria-pressed="false"
              >
                <span className="donate-cta__icon">
                  <svg
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                  >
                    <clipPath id="a">
                      <path d="m0 0h24v24h-24z" />
                    </clipPath>
                    <g clipPath="url(#a)">
                      <path d="m19.53 5.57c-1.95-1.99-5.14-2.02-7.12-.08-.03.02-.05.05-.08.08l-.33.27-.33-.33c-1.95-1.99-5.14-2.02-7.12-.08-.03.02-.05.05-.08.08-1.97 2.02-1.97 5.24 0 7.26l7.53 7.64 7.53-7.58c1.97-2.02 1.97-5.24 0-7.26z" />
                    </g>
                  </svg>{" "}
                </span>
                Donate
              </button>
              <ul
                className="donate-menu__list"
                aria-expanded="false"
                aria-label="Donate menu items"
              >
                <li className="donate-menu__item">
                  <a
                    href="https://secure.habitat.org/site/Donation2?df_id=6492&6492.donation=form1&keyword=button-header-single"
                    className="lb-btn btn-donate"
                    role="button"
                  >
                    Donate Now{" "}
                  </a>
                </li>
                <li className="donate-menu__item">
                  <a
                    href="https://secure.habitat.org/site/Donation2?df_id=4976&keyword=button-header-hopebuilder"
                    className="lb-btn btn-donate"
                    role="button"
                  >
                    Donate Monthly{" "}
                  </a>
                </li>
              </ul>
            </nav>
            <button className="header__main-menu-control">
              <span className="header__main-menu-open-icon">
                <svg
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <clipPath id="a">
                    <path d="m0 0h24v24h-24z" />
                  </clipPath>
                  <g clipPath="url(#a)">
                    <path d="m3.47 4.51h17.06c.23 0 .43.15.47.37v2.25c-.04.22-.24.38-.47.37h-17.06c-.23 0-.43-.15-.47-.37v-2.06c-.04-.27.16-.52.43-.56z" />
                    <path d="m3.47 10.51h17.06c.23 0 .43.15.47.37v2.25c-.04.22-.24.38-.47.37h-17.06c-.23 0-.43-.15-.47-.37v-2.06c-.04-.27.16-.52.43-.56z" />
                    <path d="m3.47 16.49h17.06c.23 0 .43.15.47.37v2.25c-.04.22-.24.38-.47.37h-17.06c-.23 0-.43-.15-.47-.37v-2.06c-.04-.27.16-.52.43-.56z" />
                  </g>
                </svg>
              </span>
              <span className="header__main-menu-close-icon">
                <svg
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <clipPath id="a">
                    <path d="m0 0h24v24h-24z" />
                  </clipPath>
                  <g clipPath="url(#a)">
                    <path d="m7.03 4.91 12.06 12.06c.17.16.19.41.07.6l-1.59 1.59c-.19.13-.44.1-.6-.07l-12.06-12.06c-.17-.16-.19-.41-.07-.6l1.46-1.46c.17-.22.48-.26.7-.09.01 0 .02.02.03.03z" />
                    <path d="m19.09 7.03-12.06 12.06c-.16.17-.41.19-.6.07l-1.59-1.59c-.13-.19-.1-.44.07-.6l12.06-12.06c.16-.17.41-.19.6-.07l1.46 1.46c.22.17.26.48.09.7 0 .01-.02.02-.03.03z" />
                  </g>
                </svg>
              </span>
              Menu
            </button>
          </div>
        </div>
      </header>
      <div data-drupal-messages-fallback="" className="hidden" />
    
      <main role="main">
        <a id="main-content" tabIndex={-1} />
        <div className="page__content">
          <div id="block-hab-theme-content">
            <article data-history-node-id={1}>
              <div>
                <div>
                  <div className="l-center">
                    <article className="hero hero-dark-blue hero-box-side-left ">
                      <div className="hero__img hero-dark-blue__img hero-box-side-left__img">
                        <a
                          className="hero__img-link hero-dark-blue__img-link hero-box-side-left__img-link"
                          href="https://secure.habitat.org/site/Donation2?df_id=4973&keyword=hero-homepage"
                        >
                          <div>
                            <div className="inline-image">
                              <img
                                srcSet="https://www.habitat.org/sites/default/files/styles/2_1_xsmall/public/hero_images/homeowner-kids-puppy-argentina.jpg?itok=J6LQKr-2  350w,https://www.habitat.org/sites/default/files/styles/2_1_small/public/hero_images/homeowner-kids-puppy-argentina.jpg?itok=4sOy0ZX2  638w,https://www.habitat.org/sites/default/files/styles/2_1_medium/public/hero_images/homeowner-kids-puppy-argentina.jpg?itok=pqxF89oi  855w,https://www.habitat.org/sites/default/files/styles/2_1_large/public/hero_images/homeowner-kids-puppy-argentina.jpg?itok=3BIDfNbM  1038w,https://www.habitat.org/sites/default/files/styles/2_1_xlarge/public/hero_images/homeowner-kids-puppy-argentina.jpg?itok=vuqXcYJo  1200w,https://www.habitat.org/sites/default/files/styles/2_1_default/public/hero_images/homeowner-kids-puppy-argentina.jpg?itok=nubZEOr8  1280w"
                                sizes="(max-width: 1215px) 100vw, 1280px"
                                width={350}
                                height={175}
                                src="https://www.habitat.org/sites/default/files/styles/2_1_xsmall/public/hero_images/homeowner-kids-puppy-argentina.jpg?itok=J6LQKr-2"
                                alt="Two children smiling with puppy in front of house"
                                loading="lazy"
                              />
                            </div>
                          </div>
                        </a>
                      </div>
                      <div className="hero__content hero-dark-blue__content hero-box-side-left__content">
                        <div className="hero__content-background hero-dark-blue__content-background hero-box-side-left__content-background" />
                        <div className="hero__content-inner hero-dark-blue__content-inner hero-box-side-left__content-inner">
                          <h1 className="hero__heading hero-dark-blue__heading hero-box-side-left__heading">
                            <a
                              className="hero__link hero-dark-blue__link hero-box-side-left__link"
                              href="https://secure.habitat.org/site/Donation2?df_id=4973&keyword=hero-homepage"
                            >
                              Every donation
                            </a>
                          </h1>
                          <h2 className="hero__desc hero-dark-blue__desc hero-box-side-left__desc">
                            helps a family build a safe and affordable home.
                          </h2>
                          <a
                            href="https://secure.habitat.org/site/Donation2?df_id=4973&keyword=hero-homepage"
                            className="hero__btn hero-dark-blue__btn hero-box-side-left__btn btn btn--primary"
                          >
                            Donate now
                          </a>
                        </div>
                      </div>
                    </article>
                  </div>
                  <div className="l-center">
                    <div className="basic-text">
                      <div />
                    </div>
                    <div style={{ clear: "both" }} />
                  </div>
                  <div className="l-center">
                    <section className="spacer spacer--3x"></section>
                  </div>
                  <div className="l-center">
                    <section className="l-two-up l-two-up--30-70">
                      <div className="l-two-up__col l-padded " style={{}}>
                        <div className="paragraph paragraph--type--image paragraph--view-mode--default">
                          <div className="media-item">
                            <figure className="media-item__image">
                              <img
                                src="https://www.habitat.org/sites/default/files/styles/780w/public/2018-05/icon-house.png?itok=beg84oiG"
                                width={600}
                                height={400}
                                alt="house icon"
                                loading="lazy"
                              />
                              <figcaption className="media-item__caption"></figcaption>
                            </figure>
                          </div>
                        </div>
                      </div>
                      <div className="l-two-up__col l-padded " style={{}}>
                        <div className="basic-text">
                          <div>
                            <h2>
                              We build strength, stability and self-reliance
                              through shelter.
                            </h2>
                            <p>
                              Habitat for Humanity is a nonprofit organization
                              that helps families build and improve places to
                              call home. We believe affordable housing plays a
                              critical role in strong and stable communities.
                            </p>
                            <p>
                              <a
                                className="btn btn--secondary"
                                href="/our-work?keyword=brand-button"
                              >
                                Learn about our work
                              </a>
                            </p>
                          </div>
                        </div>
                        <div style={{ clear: "both" }} />
                      </div>
                    </section>
                  </div>
                  <div className="l-center">
                    <section className="spacer spacer--1x"></section>
                  </div>
                  <div className="l-center">
                    <section className="promo-grid">
                      <div className="promo-grid__item">
                        <div className="promo-grid__nested">
                          <div
                            id="form-cta--get-local"
                            className="form-cta form-cta--get-local form-cta--zip"
                          >
                            <h2 className="form-cta__heading">
                              <svg
                                aria-hidden="true"
                                role="img"
                                className="form-cta__icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width={32}
                                height={36}
                                viewBox="0 0 32 36"
                              >
                                <path d="M19.7 35.3c-1.7.3-3.5.2-5.1-.3-3.4-.9-5.1-3.6-5.9-4.6-1.8-2.3-3.5-4.7-5.2-7.1-.7-1-1.6-2.1-2.3-3.2-.6-1.1-.4-2.3.7-3.1 1-.7 2.3-.5 3.2.5 1.2 1.4 3.9 4.7 4 4.8.3.3.6.5 1 .3s.5-.6.4-1c-.1-.7-2.4-16.8-2.4-17.2.1-1.1.9-2 2-2 1.1-.1 2.1.6 2.3 1.7.5 2.8 1.5 9.9 1.6 10.5 0 .2.1.6.4.5.4 0 .3-.4.3-.6-.1-2.6-.5-10.3-.5-11.6-.1-1.5.7-2.5 2.1-2.6 1.3-.1 2.3.9 2.3 2.4.2 3.9.4 7.7.6 11.6 0 .3-.1.9.4.9.6 0 .4-.6.4-.9.3-3.4.5-6.7.8-10.1.1-1.4 1.1-2.3 2.4-2.2 1.3.1 2.1 1.1 2 2.6-.2 3.2-.8 10.4-.9 10.8 0 .3 0 .6.4.7.4.1.5-.3.6-.6.3-1.1 1.2-5.7 1.5-6.9.3-1.4 1.4-2.1 2.6-1.9 1.2.3 2 1.4 1.7 2.8-.6 3.1-2.8 13.7-3.3 15.8-.9 4.1-2.7 9.2-8.1 10z" />
                              </svg>
                              <a
                                href="#form-cta--get-local"
                                data-toggle-class="is-open"
                                data-target="#form-cta--get-local"
                                className="form-cta__trigger"
                                data-listener="true"
                              >
                                <div>Find your local Habitat</div>
                              </a>
                              <span className="form-cta__title">
                                <div>Find your local Habitat</div>
                              </span>
                            </h2>
                            <div className="form-cta__collapsible">
                              <div className="form-cta__bottom">
                                <div className="form-cta__text">
                                  <div>
                                    Find a Habitat near you to volunteer, shop
                                    at a Habitat ReStore and more.
                                  </div>
                                </div>
                                <div className="form-cta__form">
                                  <form
                                    data-drupal-selector="hab-component-us-ca-zip-search-form"
                                    action="/"
                                    method="post"
                                    id="hab-component-us-ca-zip-search-form"
                                    acceptCharset="UTF-8"
                                  >
                                    <input
                                      aria-label="ZIP code"
                                      placeholder="ZIP code"
                                      data-drupal-selector="edit-formcta-zip-code"
                                      type="text"
                                      id="edit-formcta-zip-code"
                                      name="formcta_zip_code"
                                      defaultValue=""
                                      size={60}
                                      maxLength={128}
                                      className="form-text form-item__text"
                                    />
                                    <button
                                      className="form-cta__btn button js-form-submit form-submit btn"
                                      data-drupal-selector="edit-formcta-submit"
                                      type="submit"
                                      id="edit-formcta-submit"
                                      name="op"
                                      value="Search now"
                                    >
                                      Search now
                                    </button>
                                    <input
                                      autoComplete="off"
                                      data-drupal-selector="form-qfocte7laruzzuyhlsb4vwfcbcpxnyhkuk8ng6-jesa"
                                      type="hidden"
                                      name="form_build_id"
                                      defaultValue="form-QfoCTe7laRuzZUYHlSB4VwfCBCPXNYhKuk8Ng6-JeSA"
                                      className="form-item__text"
                                    />
                                    <input
                                      data-drupal-selector="edit-hab-component-us-ca-zip-search-form"
                                      type="hidden"
                                      name="form_id"
                                      defaultValue="hab_component_us_ca_zip_search_form"
                                      className="form-item__text"
                                    />
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="form-cta-single form-cta-single--hot-orange">
                            <h2 className="form-cta-single__heading">
                              <svg
                                aria-hidden="true"
                                role="img"
                                className="form-cta-single__icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width={34}
                                height={31}
                                viewBox="0 0 34 31"
                              >
                                <path d="M30.8 3.8C27.2.1 21.2.1 17.6 3.8l-.6.5-.6-.6C12.8 0 6.8 0 3.2 3.7-.4 7.4-.4 13.4 3.2 17L17 31l13.8-13.9c3.6-3.7 3.6-9.7 0-13.3z" />
                              </svg>
                              <span className="form-cta-single__title">
                                Donate
                              </span>
                            </h2>
                            <div className="form-cta-single__bottom">
                              <div className="form-cta-single__text">
                                <p>
                                  Families who partner with us build their own
                                  homes alongside volunteers, pay an affordable
                                  mortgage and are grateful for your help.
                                </p>
                              </div>
                              <a
                                className="form-cta-single__btn"
                                aria-label="Donate"
                                href="https://secure.habitat.org/site/Donation2?idb=812850470&df_id=4973&4973.donation=form1&keyword=promo-homepage"
                              >
                                Donate
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="promo-grid__bottom">
                        <div>
                          <article className="promo ">
                            <div className="promo__img">
                              <a
                                className="promo__img-link"
                                href="https://www.habitat.org/multimedia/annual-report-2023/?keyword=promo1--home"
                              >
                                {" "}
                                <img
                                  srcSet="https://www.habitat.org/sites/default/files/styles/3_4_small/public/2024-01/promo2-ar23.jpg?itok=QaJfnFBk  250w,https://www.habitat.org/sites/default/files/styles/3_4_medium/public/2024-01/promo2-ar23.jpg?itok=xgsY35tI  489w,https://www.habitat.org/sites/default/files/styles/3_4_large/public/2024-01/promo2-ar23.jpg?itok=xJQaxf4z  600w"
                                  sizes="(max-width: 1200px) 50vw, 600px"
                                  width={250}
                                  height={333}
                                  src="https://www.habitat.org/sites/default/files/styles/3_4_small/public/2024-01/promo2-ar23.jpg?itok=QaJfnFBk"
                                  alt="Photo collage of homeowners, children, and advocates from around the world."
                                  loading="lazy"
                                />
                              </a>
                            </div>
                            <div className="promo__gradient" />
                            <div className="promo__content">
                              <h2 className="promo__heading">
                                <a
                                  className="promo__link"
                                  href="https://www.habitat.org/multimedia/annual-report-2023/?keyword=promo1--home"
                                >
                                  Check out our latest interactive annual
                                  report!
                                </a>
                              </h2>
                              <a
                                href="https://www.habitat.org/multimedia/annual-report-2023/?keyword=promo1--home"
                                className="promo__btn btn btn--primary"
                              >
                                Take a look
                              </a>
                            </div>
                          </article>
                        </div>
                      </div>
                      <div className="promo-grid__bottom promo--grid-short">
                        <div>
                          <article className="promo ">
                            <div className="promo__img">
                              <a
                                className="promo__img-link"
                                href="https://www.habitat.org/costofhome/impact?keyword=promo2--home"
                              >
                                {" "}
                                <img
                                  srcSet="https://www.habitat.org/sites/default/files/styles/3_4_small/public/2024-01/promo-dc-building-g1.png?itok=QirIxgWO  250w,https://www.habitat.org/sites/default/files/styles/3_4_medium/public/2024-01/promo-dc-building-g1.png?itok=e45A_-kJ  489w,https://www.habitat.org/sites/default/files/styles/3_4_large/public/2024-01/promo-dc-building-g1.png?itok=rQZ32O-_  600w"
                                  sizes="(max-width: 1200px) 50vw, 600px"
                                  width={250}
                                  height={333}
                                  src="https://www.habitat.org/sites/default/files/styles/3_4_small/public/2024-01/promo-dc-building-g1.png?itok=QirIxgWO"
                                  alt="Capitol building in Washington, D.C."
                                  loading="lazy"
                                />
                              </a>
                            </div>
                            <div className="promo__gradient" />
                            <div className="promo__content">
                              <h2 className="promo__heading">
                                <a
                                  className="promo__link"
                                  href="https://www.habitat.org/costofhome/impact?keyword=promo2--home"
                                >
                                  Our advocacy wins: 300+ policy successes
                                </a>
                              </h2>
                              <a
                                href="https://www.habitat.org/costofhome/impact?keyword=promo2--home"
                                className="promo__btn btn btn--primary"
                              >
                                Learn more
                              </a>
                            </div>
                          </article>
                        </div>
                      </div>
                      <div className="promo-grid__item">
                        <div
                          id="form-cta--subscribe"
                          className="form-cta form-cta--subscribe"
                        >
                          <h2 className="form-cta__heading">
                            <svg
                              aria-hidden="true"
                              role="img"
                              className="form-cta__icon"
                              xmlns="http://www.w3.org/2000/svg"
                              width={36}
                              height={32}
                              viewBox="0 0 36 32"
                            >
                              <path d="M25.7 7.9L18 15.6l-7.7-7.7L12.1 6l4.5 4.5V.7h2.6v9.9l4.5-4.5 2 1.8zm9.8 11.8L28.6 9.4l-.8.8-2.1 2.1 5 7.5h-7.5l-1.9 3.9h-6.8l-1.9-3.9H5.1l5-7.5L8 10.2l-.8-.8L.5 19.7v11.7h35V19.7z" />
                            </svg>
                            <a
                              href="#form-cta--subscribe"
                              data-toggle-class="is-open"
                              data-target="#form-cta--subscribe"
                              className="form-cta__trigger"
                              data-listener="true"
                            >
                              <div>Subscribe</div>
                            </a>
                            <span className="form-cta__title">
                              <div>Subscribe</div>
                            </span>
                          </h2>
                          <div className="form-cta__collapsible">
                            <div className="form-cta__bottom">
                              <div className="form-cta__text">
                                <div>
                                  <p>
                                    Sign up for our monthly newsletter to get
                                    the latest news, volunteer opportunities,
                                    DIY tips and other ways to get involved with
                                    Habitat for Humanity.
                                  </p>
                                </div>
                              </div>
                              <div className="form-cta__form">
                                <div id="hab-component-newsletter-subscription-form-ajax">
                                  <form
                                    data-drupal-selector="hab-component-newsletter-subscription-form"
                                    action="/"
                                    method="post"
                                    id="hab-component-newsletter-subscription-form"
                                    acceptCharset="UTF-8"
                                  >
                                    <input
                                      aria-label="Email address"
                                      placeholder="Email address"
                                      data-drupal-selector="edit-formcta-email-address"
                                      type="email"
                                      id="edit-formcta-email-address"
                                      name="formcta_email_address"
                                      defaultValue=""
                                      size={60}
                                      maxLength={254}
                                      className="form-email required"
                                      required="required"
                                      aria-required="true"
                                    />
                                    <input
                                      data-drupal-selector="edit-interest-ids"
                                      type="hidden"
                                      name="interest_ids"
                                      defaultValue={1702}
                                      className="form-item__text"
                                    />
                                    <input
                                      data-drupal-selector="edit-group-ids"
                                      type="hidden"
                                      name="group_ids"
                                      className="form-item__text"
                                    />
                                    <input
                                      className="form-cta__btn button js-form-submit form-submit btn btn--primary"
                                      data-drupal-selector="edit-hab-component-newsletter-subscription-form-submit"
                                      type="submit"
                                      id="edit-hab-component-newsletter-subscription-form-submit"
                                      name="op"
                                      defaultValue="Subscribe"
                                      data-once="drupal-ajax"
                                    />
                                    <input
                                      autoComplete="off"
                                      data-drupal-selector="form-7r2lqzbadkrnicow3dekjzdy8qof6mt2aiucg5e9ooy"
                                      type="hidden"
                                      name="form_build_id"
                                      defaultValue="form-7R2LqZbadKRnicOw3dEKJzdy8QOf6mT2aIuCG5e9OOY"
                                      className="form-item__text"
                                    />
                                    <input
                                      data-drupal-selector="edit-hab-component-newsletter-subscription-form"
                                      type="hidden"
                                      name="form_id"
                                      defaultValue="hab_component_newsletter_subscription_form"
                                      className="form-item__text"
                                    />
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                  <div className="l-center">
                    <section className="spacer spacer--2x"></section>
                  </div>
                  <div className="l-center">
                    <div>
                      <div className="section-title ">
                        <h2 className="section-title__heading">
                          Habitat features
                        </h2>
                      </div>
                    </div>
                  </div>
                  <div className="l-center">
                    {" "}
                    <div
                      data-id={41101}
                      className="paragraph paragraph--type--content-list-manual paragraph--view-mode--default"
                    >
                      <div
                        className="content-list__container"
                        data-layout-type="3up-grid"
                        data-color-style="neutral"
                      >
                        <div className="content-list l-grid content-list--3up-grid content-list--neutral default">
                          <article
                            className="teaser l-grid__col l-grid__col-third"
                            style={{ display: "flex" }}
                          >
                            <div className="teaser__img">
                              <a
                                className="teaser__img-link"
                                href="/stories/rockefeller-center-christmas-trees-journey-habitat-home"
                              >
                                {" "}
                                <img
                                  srcSet="https://www.habitat.org/sites/default/files/styles/16_9_small/public/2016-10/video-pvw-rockefeller-tree_0.jpg?itok=Ay8lINXe  350w,https://www.habitat.org/sites/default/files/styles/16_9_medium/public/2016-10/video-pvw-rockefeller-tree_0.jpg?itok=wocmWS9U  738w,https://www.habitat.org/sites/default/files/styles/16_9_default/public/2016-10/video-pvw-rockefeller-tree_0.jpg?itok=Q5Tcogpv  800w"
                                  sizes="(max-width: 703px) 100vw, (max-width: 879px) 50vw, (max-width: 1215px) 33vw, 387px"
                                  width={350}
                                  height={197}
                                  src="https://www.habitat.org/sites/default/files/styles/16_9_small/public/2016-10/video-pvw-rockefeller-tree_0.jpg?itok=Ay8lINXe"
                                  alt="Rockefeller Center Christmas tree, From shade to shelter, Habitat for Humanity"
                                  loading="lazy"
                                />
                              </a>
                            </div>
                            <div className="teaser__content">
                              <h3 className="teaser__heading">
                                <a
                                  className="teaser__link"
                                  href="/stories/rockefeller-center-christmas-trees-journey-habitat-home"
                                >
                                  Rockefeller Center Christmas tree’s journey
                                  into a Habitat home
                                </a>
                              </h3>
                              <p className="teaser__desc">
                                Each year since 2007, lumber milled from the
                                Rockefeller Center Christmas tree has been used
                                to help a family build their Habitat house.
                              </p>
                              <a
                                href="/stories/rockefeller-center-christmas-trees-journey-habitat-home"
                                className="teaser__btn btn btn--secondary "
                              >
                                Read more
                              </a>
                            </div>
                          </article>
                          <article
                            className="teaser l-grid__col l-grid__col-third"
                            style={{ display: "flex" }}
                          >
                            <div className="teaser__img">
                              <a
                                className="teaser__img-link"
                                href="/honoringrosalynncarter/stories"
                              >
                                <div className="inline-image">
                                  <img
                                    srcSet="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/hero-JR_Carter_Center_1.png?itok=dM5Bkqwl  350w,https://www.habitat.org/sites/default/files/styles/16_9_medium/public/images/hero-JR_Carter_Center_1.png?itok=M_cbeH3y  738w,https://www.habitat.org/sites/default/files/styles/16_9_default/public/images/hero-JR_Carter_Center_1.png?itok=L4dgsMFD  800w"
                                    sizes="(max-width: 703px) 100vw, (max-width: 879px) 50vw, (max-width: 1215px) 33vw, 387px"
                                    width={350}
                                    height={197}
                                    src="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/hero-JR_Carter_Center_1.png?itok=dM5Bkqwl"
                                    alt='Blue hard hat with butterfly sticker and signed by Habitat CEO Jonathan Reckford with the message "Thank you for blessing the world with your compassion and commitment to service"'
                                    loading="lazy"
                                  />
                                </div>
                              </a>
                            </div>
                            <div className="teaser__content">
                              <h3 className="teaser__heading">
                                <a
                                  className="teaser__link"
                                  href="/honoringrosalynncarter/stories"
                                >
                                  Rosalynn Carter’s impact on Habitat
                                </a>
                              </h3>
                              <p className="teaser__desc">
                                Look back on Mrs. Carter’s extraordinary legacy
                                and&nbsp;hands-on commitment to Habitat’s
                                mission.
                              </p>
                              <a
                                href="/honoringrosalynncarter/stories"
                                className="teaser__btn btn btn--secondary "
                              >
                                Read stories
                              </a>
                            </div>
                          </article>
                          <article
                            className="teaser l-grid__col l-grid__col-third"
                            style={{ display: "flex" }}
                          >
                            <div className="teaser__img">
                              <a
                                className="teaser__img-link"
                                href="/givingthanks"
                              >
                                <div className="inline-image">
                                  <img
                                    srcSet="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/Dec2022LowesChallenge_Hero2.jpg?itok=gRl0rPO_  350w,https://www.habitat.org/sites/default/files/styles/16_9_medium/public/images/Dec2022LowesChallenge_Hero2.jpg?itok=PyLvJxwk  738w,https://www.habitat.org/sites/default/files/styles/16_9_default/public/images/Dec2022LowesChallenge_Hero2.jpg?itok=mqqwW3Ab  800w"
                                    sizes="(max-width: 703px) 100vw, (max-width: 879px) 50vw, (max-width: 1215px) 33vw, 387px"
                                    width={350}
                                    height={197}
                                    src="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/Dec2022LowesChallenge_Hero2.jpg?itok=gRl0rPO_"
                                    alt="Family of five smiling in front of their Habitat home"
                                    loading="lazy"
                                  />
                                </div>
                              </a>
                            </div>
                            <div className="teaser__content">
                              <h3 className="teaser__heading">
                                <a
                                  className="teaser__link"
                                  href="/givingthanks"
                                >
                                  Giving thanks to our supporters
                                </a>
                              </h3>
                              <p className="teaser__desc">
                                Enjoy this special video message from our CEO
                                and a few Habitat homeowners. Thank you for
                                partnering with us to build homes, communities
                                and hope!
                              </p>
                              <a
                                href="/givingthanks"
                                className="teaser__btn btn btn--secondary "
                              >
                                Watch video
                              </a>
                            </div>
                          </article>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="l-center">
                    {" "}
                    <div
                      data-id={12897}
                      className="paragraph paragraph--type--content-list-manual paragraph--view-mode--default"
                    >
                      <div
                        className="content-list__container"
                        data-layout-type="3up-grid"
                        data-color-style="neutral"
                      >
                        <div className="content-list l-grid content-list--3up-grid content-list--neutral default">
                          <article className="teaser l-grid__col l-grid__col-third">
                            <div className="teaser__img">
                              <a
                                className="teaser__img-link"
                                href="/carter-work-project/through-the-years"
                              >
                                <div className="inline-image">
                                  <img
                                    srcSet="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/JCWP90-036-11%20%281%29-png.png?itok=oJYRUskq  350w,https://www.habitat.org/sites/default/files/styles/16_9_medium/public/images/JCWP90-036-11%20%281%29-png.png?itok=jgpP5v5P  738w,https://www.habitat.org/sites/default/files/styles/16_9_default/public/images/JCWP90-036-11%20%281%29-png.png?itok=JzRcULXc  800w"
                                    sizes="(max-width: 703px) 100vw, (max-width: 879px) 50vw, (max-width: 1215px) 33vw, 387px"
                                    width={350}
                                    height={197}
                                    src="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/JCWP90-036-11%20%281%29-png.png?itok=oJYRUskq"
                                    alt="President and Mrs. Carter walking with a crowd of volunteers."
                                    loading="lazy"
                                  />
                                </div>
                              </a>
                            </div>
                            <div className="teaser__content">
                              <h3 className="teaser__heading">
                                <a
                                  className="teaser__link"
                                  href="/carter-work-project/through-the-years"
                                >
                                  Carter Work Projects through the years
                                </a>
                              </h3>
                              <p className="teaser__desc">
                                Since 1984, President and Mrs. Carter have been
                                building and advocating for affordable housing
                                alongside Habitat for Humanity for over 30
                                years. Journey through the&nbsp;incredible
                                legacy of Carter Work Projects!
                              </p>
                              <a
                                href="/carter-work-project/through-the-years"
                                className="teaser__btn btn btn--secondary "
                              >
                                Learn more
                              </a>
                            </div>
                          </article>
                          <article className="teaser l-grid__col l-grid__col-third">
                            <div className="teaser__img">
                              <a
                                className="teaser__img-link"
                                href="https://www.habitat.org/multimedia/annual-report-2023/"
                              >
                                <div className="inline-image">
                                  <img
                                    srcSet="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/teaser-ar23.jpg?itok=UZsJILN4  350w,https://www.habitat.org/sites/default/files/styles/16_9_medium/public/images/teaser-ar23.jpg?itok=sgyGoUwp  738w,https://www.habitat.org/sites/default/files/styles/16_9_default/public/images/teaser-ar23.jpg?itok=1w5cUvm1  800w"
                                    sizes="(max-width: 703px) 100vw, (max-width: 879px) 50vw, (max-width: 1215px) 33vw, 387px"
                                    width={350}
                                    height={197}
                                    src="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/teaser-ar23.jpg?itok=UZsJILN4"
                                    alt="Two people in brightly colored clothing discussing paperwork while sitting on a straw mat outside with small concrete homes visible in background."
                                    loading="lazy"
                                  />
                                </div>
                              </a>
                            </div>
                            <div className="teaser__content">
                              <h3 className="teaser__heading">
                                <a
                                  className="teaser__link"
                                  href="https://www.habitat.org/multimedia/annual-report-2023/"
                                >
                                  2023: Catalyzing communities for global
                                  solutions
                                </a>
                              </h3>
                              <p className="teaser__desc">
                                In fiscal year 2023, we helped 13.4 million
                                people build or improve a place to call home.
                                Take a look through our interactive annual
                                report&nbsp;celebrating the impact our work has
                                made in communities around the world over the
                                past year.
                              </p>
                              <a
                                href="https://www.habitat.org/multimedia/annual-report-2023/"
                                className="teaser__btn btn btn--secondary "
                              >
                                Learn more
                              </a>
                            </div>
                          </article>
                          <article className="teaser l-grid__col l-grid__col-third">
                            <div className="teaser__img">
                              <a
                                className="teaser__img-link"
                                href="/carter-work-project/habitat-humanitarians-carters"
                              >
                                <div className="inline-image">
                                  <img
                                    srcSet="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/14-carter-work-project.jpg?itok=LPCS3vcU  350w,https://www.habitat.org/sites/default/files/styles/16_9_medium/public/images/14-carter-work-project.jpg?itok=r1QHBXJw  738w,https://www.habitat.org/sites/default/files/styles/16_9_default/public/images/14-carter-work-project.jpg?itok=lOsnsp20  800w"
                                    sizes="(max-width: 703px) 100vw, (max-width: 879px) 50vw, (max-width: 1215px) 33vw, 387px"
                                    width={350}
                                    height={197}
                                    src="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/14-carter-work-project.jpg?itok=LPCS3vcU"
                                    alt="The Carters laughing and talking with volunteers and homeowners."
                                    loading="lazy"
                                  />
                                </div>
                              </a>
                            </div>
                            <div className="teaser__content">
                              <h3 className="teaser__heading">
                                <a
                                  className="teaser__link"
                                  href="/carter-work-project/habitat-humanitarians-carters"
                                >
                                  Habitat Humanitarians: The Carters
                                </a>
                              </h3>
                              <p className="teaser__desc">
                                Since 1984, President and Mrs. Carter have been
                                champions and groudbreaking voices for
                                affordable, decent housing for all, donating
                                their time and leadership each year to build and
                                improve homes through Habitat’s Carter Work
                                Project.
                              </p>
                              <a
                                href="/carter-work-project/habitat-humanitarians-carters"
                                className="teaser__btn btn btn--secondary "
                              >
                                Read more
                              </a>
                            </div>
                          </article>
                          <article className="teaser l-grid__col l-grid__col-third visually-hidden">
                            <div className="teaser__img">
                              <a
                                className="teaser__img-link"
                                href="/stories/value-volunteering"
                              >
                                <div className="inline-image">
                                  <img
                                    srcSet="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/2022.06.28-MP%26I.gif?itok=zxVY7aWI  350w,https://www.habitat.org/sites/default/files/styles/16_9_medium/public/images/2022.06.28-MP%26I.gif?itok=uElC2VTC  738w,https://www.habitat.org/sites/default/files/styles/16_9_default/public/images/2022.06.28-MP%26I.gif?itok=Gh7fia4v  800w"
                                    sizes="(max-width: 703px) 100vw, (max-width: 879px) 50vw, (max-width: 1215px) 33vw, 387px"
                                    width={350}
                                    height={197}
                                    src="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/2022.06.28-MP%26I.gif?itok=zxVY7aWI"
                                    alt="Home is the Key build day with O-Cedar and At Home. "
                                    loading="lazy"
                                  />
                                </div>
                              </a>
                            </div>
                            <div className="teaser__content">
                              <h3 className="teaser__heading">
                                <a
                                  className="teaser__link"
                                  href="/stories/value-volunteering"
                                >
                                  The value of volunteering
                                </a>
                              </h3>
                              <p className="teaser__desc">
                                Research has shown that volunteering is
                                associated with improved health and well-being,
                                including increased longevity, adoption of
                                healthy lifestyles and reduction in depression
                                and stress. Dive into the research around these
                                benefits in our evidence brief.
                              </p>
                              <a
                                href="/stories/value-volunteering"
                                className="teaser__btn btn btn--secondary "
                              >
                                Read more
                              </a>
                            </div>
                          </article>
                          <article className="teaser l-grid__col l-grid__col-third visually-hidden">
                            <div className="teaser__img">
                              <a
                                className="teaser__img-link"
                                href="/stories/should-i-donate-habitat-restore"
                              >
                                {" "}
                                <img
                                  srcSet="https://www.habitat.org/sites/default/files/styles/16_9_small/public/2021-05/teaser-donatereuserecycle-restore.png?itok=mruTBMQg  350w,https://www.habitat.org/sites/default/files/styles/16_9_medium/public/2021-05/teaser-donatereuserecycle-restore.png?itok=_N4Vy8T2  738w,https://www.habitat.org/sites/default/files/styles/16_9_default/public/2021-05/teaser-donatereuserecycle-restore.png?itok=oqSAGara  800w"
                                  sizes="(max-width: 703px) 100vw, (max-width: 879px) 50vw, (max-width: 1215px) 33vw, 387px"
                                  width={350}
                                  height={197}
                                  src="https://www.habitat.org/sites/default/files/styles/16_9_small/public/2021-05/teaser-donatereuserecycle-restore.png?itok=mruTBMQg"
                                  alt="graphic showing someone donating a chair at Habitat ReStore."
                                  loading="lazy"
                                />
                              </a>
                            </div>
                            <div className="teaser__content">
                              <h3 className="teaser__heading">
                                <a
                                  className="teaser__link"
                                  href="/stories/should-i-donate-habitat-restore"
                                >
                                  Should I donate this to the Habitat ReStore?
                                </a>
                              </h3>
                              <p className="teaser__desc">
                                When cleaning, remodeling or moving, you often
                                run into household items you no longer use, but
                                that are still in great condition. Whether it be
                                items like the windows you just replaced or an
                                old TV, you may wonder, “Should I donate this?”
                              </p>
                              <a
                                href="/stories/should-i-donate-habitat-restore"
                                className="teaser__btn btn btn--secondary "
                              >
                                Read more
                              </a>
                            </div>
                          </article>
                          <article className="teaser l-grid__col l-grid__col-third visually-hidden">
                            <div className="teaser__img">
                              <a
                                className="teaser__img-link"
                                href="/carter-work-project/5-faces-2023-carter-work-project"
                              >
                                <div className="inline-image">
                                  <img
                                    srcSet="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/USNC-23-KM-100-08028-hero.jpg?itok=eHY5p8Dr  350w,https://www.habitat.org/sites/default/files/styles/16_9_medium/public/images/USNC-23-KM-100-08028-hero.jpg?itok=HJcVhKXq  738w,https://www.habitat.org/sites/default/files/styles/16_9_default/public/images/USNC-23-KM-100-08028-hero.jpg?itok=z0lQ_9E9  800w"
                                    sizes="(max-width: 703px) 100vw, (max-width: 879px) 50vw, (max-width: 1215px) 33vw, 387px"
                                    width={350}
                                    height={197}
                                    src="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/USNC-23-KM-100-08028-hero.jpg?itok=eHY5p8Dr"
                                    alt="Amia stands with her arm in a doorway smiling at the camera."
                                    loading="lazy"
                                  />
                                </div>
                              </a>
                            </div>
                            <div className="teaser__content">
                              <h3 className="teaser__heading">
                                <a
                                  className="teaser__link"
                                  href="/carter-work-project/5-faces-2023-carter-work-project"
                                >
                                  5 faces of the 2023 Carter Work Project{" "}
                                </a>
                              </h3>
                              <p className="teaser__desc">
                                “If you’ve ever wondered what love sounds like,
                                you’re about to hear it,” Garth Brooks said to
                                the homeowners and volunteers gathered during
                                the 2023 Carter Work Project in Charlotte, North
                                Carolina.&nbsp;Here are just a few of the faces
                                that bring the time, talent and gifts needed to
                                make the project possible.&nbsp; &nbsp;
                              </p>
                              <a
                                href="/carter-work-project/5-faces-2023-carter-work-project"
                                className="teaser__btn btn btn--secondary "
                              >
                                Learn more
                              </a>
                            </div>
                          </article>
                          <article className="teaser l-grid__col l-grid__col-third visually-hidden">
                            <div className="teaser__img">
                              <a
                                className="teaser__img-link"
                                href="/our-work/advancing-black-homeownership"
                              >
                                <div className="inline-image">
                                  <img
                                    srcSet="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/hero-advancing-black-homeownership.jpg?itok=iKpaAR5s  350w,https://www.habitat.org/sites/default/files/styles/16_9_medium/public/images/hero-advancing-black-homeownership.jpg?itok=vYjtZE9u  738w,https://www.habitat.org/sites/default/files/styles/16_9_default/public/images/hero-advancing-black-homeownership.jpg?itok=yZrGXAG0  800w"
                                    sizes="(max-width: 703px) 100vw, (max-width: 879px) 50vw, (max-width: 1215px) 33vw, 387px"
                                    width={350}
                                    height={197}
                                    src="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/hero-advancing-black-homeownership.jpg?itok=iKpaAR5s"
                                    alt="young blacks girl sitting on the stairs of her home, smiling"
                                    loading="lazy"
                                  />
                                </div>
                              </a>
                            </div>
                            <div className="teaser__content">
                              <h3 className="teaser__heading">
                                <a
                                  className="teaser__link"
                                  href="/our-work/advancing-black-homeownership"
                                >
                                  Advancing Black Homeownership
                                </a>
                              </h3>
                              <p className="teaser__desc">
                                Habitat for Humanity’s vision is a world where
                                everyone has a decent place to live, but a
                                structure of intentional and systemic racial
                                discrimination in the U.S. has created barriers
                                to homeownership for many Black families.
                              </p>
                              <a
                                href="/our-work/advancing-black-homeownership"
                                className="teaser__btn btn btn--secondary "
                              >
                                Learn more
                              </a>
                            </div>
                          </article>
                          <article className="teaser l-grid__col l-grid__col-third visually-hidden">
                            <div className="teaser__img">
                              <a
                                className="teaser__img-link"
                                href="/honoringrosalynncarter/stories/rosalynn-carter-and-habitat-humanity"
                              >
                                <div className="inline-image">
                                  <img
                                    srcSet="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/hero-bw-JCWP90-076-12.png?itok=HiRHi4Ym  350w,https://www.habitat.org/sites/default/files/styles/16_9_medium/public/images/hero-bw-JCWP90-076-12.png?itok=DheZrYDp  738w,https://www.habitat.org/sites/default/files/styles/16_9_default/public/images/hero-bw-JCWP90-076-12.png?itok=o-qCStGk  800w"
                                    sizes="(max-width: 703px) 100vw, (max-width: 879px) 50vw, (max-width: 1215px) 33vw, 387px"
                                    width={350}
                                    height={197}
                                    src="https://www.habitat.org/sites/default/files/styles/16_9_small/public/images/hero-bw-JCWP90-076-12.png?itok=HiRHi4Ym"
                                    alt="Black and white photo from 1990 of Rosalynn Carter smiling while working on the build site "
                                    loading="lazy"
                                  />
                                </div>
                              </a>
                            </div>
                            <div className="teaser__content">
                              <h3 className="teaser__heading">
                                <a
                                  className="teaser__link"
                                  href="/honoringrosalynncarter/stories/rosalynn-carter-and-habitat-humanity"
                                >
                                  Slideshow: Rosalynn Carter and Habitat for
                                  Humanity
                                </a>
                              </h3>
                              <p className="teaser__desc">
                                View a slideshow of Rosalynn Carter’s work with
                                Habitat for Humanity.
                              </p>
                              <a
                                href="/honoringrosalynncarter/stories/rosalynn-carter-and-habitat-humanity"
                                className="teaser__btn btn btn--secondary "
                              >
                                Read more
                              </a>
                            </div>
                          </article>
                          <article className="teaser l-grid__col l-grid__col-third visually-hidden">
                            <div className="teaser__img">
                              <a
                                className="teaser__img-link"
                                href="/our-work/impact/research-series-who-has-access-to-homeownership"
                              >
                                {" "}
                                <img
                                  srcSet="https://www.habitat.org/sites/default/files/styles/16_9_small/public/2021-01/HITK-houses.jpg?itok=Z3kQvIM9  350w,https://www.habitat.org/sites/default/files/styles/16_9_medium/public/2021-01/HITK-houses.jpg?itok=6HCHpELN  738w,https://www.habitat.org/sites/default/files/styles/16_9_default/public/2021-01/HITK-houses.jpg?itok=_t1hpOt_  800w"
                                  sizes="(max-width: 703px) 100vw, (max-width: 879px) 50vw, (max-width: 1215px) 33vw, 387px"
                                  width={350}
                                  height={197}
                                  src="https://www.habitat.org/sites/default/files/styles/16_9_small/public/2021-01/HITK-houses.jpg?itok=Z3kQvIM9"
                                  alt="A row of houses."
                                  loading="lazy"
                                />
                              </a>
                            </div>
                            <div className="teaser__content">
                              <h3 className="teaser__heading">
                                <a
                                  className="teaser__link"
                                  href="/our-work/impact/research-series-who-has-access-to-homeownership"
                                >
                                  Research series: Who has access to
                                  homeownership?
                                </a>
                              </h3>
                              <p className="teaser__desc">
                                Affordable homeownership has long-lasting and
                                life-changing impacts on households. In this
                                evidence brief,&nbsp;Habitat takes a look at who
                                currently has access to homeownership and what
                                factors play a role in the U.S.
                              </p>
                              <a
                                href="/our-work/impact/research-series-who-has-access-to-homeownership"
                                className="teaser__btn btn btn--secondary "
                              >
                                Learn more
                              </a>
                            </div>
                          </article>
                        </div>
                      </div>
                      <ul className="pager pager--container pager--load-more">
                        <li className="pager__item load-more">
                          <a
                            href=""
                            className="btn btn--secondary btn--large load-more"
                            title="Load more"
                          >
                            Load more
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
          <div className="modal-cta js-modal-cta on-exit-interstitial--horizontal mfp-hide">
            <section className="newsletter-exit">
              <div
                className="newsletter-exit__img"
                style={{
                  backgroundImage:
                    'url("/sites/default/files/images/interstitial-exit-diyguide.png")'
                }}
              >
                <div className="inline-image">
                  <img
                    src="https://www.habitat.org/sites/default/files/images/interstitial-exit-diyguide.png"
                    width={800}
                    height={450}
                    alt="make yourself at home: Home maintenance and DIY tips for homeowners"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="newsletter-exit__content">
                <h2 className="newsletter-exit__heading basic-text-h3">
                  <div>Goodbye or DIY?</div>
                </h2>
                <div className="newsletter-exit__desc">
                  <div>
                    <p>
                      Get breaking news, ways to help and our free DIY guide
                      full of helpful tips for homeowners. Join our email list
                      today.
                    </p>
                  </div>
                </div>
                <div className="newsletter-exit__form">
                  <div id="hab-component-newsletter-on-exit-subscription-form-ajax">
                    <form
                      className="newsletter-with-names"
                      data-drupal-selector="hab-component-newsletter-on-exit-subscription-form"
                      action="/"
                      method="post"
                      id="hab-component-newsletter-on-exit-subscription-form"
                      acceptCharset="UTF-8"
                    >
                      <div className="js-form-item form-item js-form-type-textfield form-item-first-name js-form-item-first-name form-float-label">
                        <input
                          aria-label="First name"
                          data-drupal-selector="edit-first-name"
                          type="text"
                          id="edit-first-name"
                          name="first_name"
                          defaultValue=""
                          size={60}
                          maxLength={128}
                          className="form-text required form-item__text"
                          required="required"
                          aria-required="true"
                        />
                        <label
                          htmlFor="edit-first-name"
                          className="option js-form-required form-required form-item__label"
                        >
                          {" "}
                          <svg
                            role="img"
                            className="icon form-item__required"
                            xmlns="http://www.w3.org/2000/svg"
                            width="15.94"
                            height="17.14"
                            viewBox="0 0 15.94 17.14"
                            focusable="false"
                          >
                            <title>This field is required.</title>
                            <path d="M15.22 10.29a1.35 1.35 0 0 1 .66.86 1.4 1.4 0 0 1-.14 1.09L15 13.47a1.35 1.35 0 0 1-.86.66 1.4 1.4 0 0 1-1.06-.13l-3-1.71v3.43a1.45 1.45 0 0 1-1.43 1.43h-1.4a1.45 1.45 0 0 1-1.43-1.43v-3.43L2.86 14a1.41 1.41 0 0 1-1.09.14 1.35 1.35 0 0 1-.87-.66l-.71-1.24a1.41 1.41 0 0 1-.14-1.09 1.34 1.34 0 0 1 .66-.86l3-1.72-3-1.72A1.35 1.35 0 0 1 .05 6a1.4 1.4 0 0 1 .14-1.1L.9 3.67A1.35 1.35 0 0 1 1.77 3a1.4 1.4 0 0 1 1.09.14l3 1.71V1.43a1.37 1.37 0 0 1 .42-1 1.37 1.37 0 0 1 1-.42h1.4a1.37 1.37 0 0 1 1 .42 1.37 1.37 0 0 1 .42 1v3.42l3-1.71A1.41 1.41 0 0 1 14.17 3a1.34 1.34 0 0 1 .87.66l.71 1.23A1.41 1.41 0 0 1 15.89 6a1.34 1.34 0 0 1-.66.86l-3 1.72z" />
                          </svg>{" "}
                          First name
                        </label>
                      </div>
                      <div className="js-form-item form-item js-form-type-textfield form-item-last-name js-form-item-last-name form-float-label">
                        <input
                          aria-label="Last name"
                          data-drupal-selector="edit-last-name"
                          type="text"
                          id="edit-last-name"
                          name="last_name"
                          defaultValue=""
                          size={60}
                          maxLength={128}
                          className="form-text required form-item__text"
                          required="required"
                          aria-required="true"
                        />
                        <label
                          htmlFor="edit-last-name"
                          className="option js-form-required form-required form-item__label"
                        >
                          {" "}
                          <svg
                            role="img"
                            className="icon form-item__required"
                            xmlns="http://www.w3.org/2000/svg"
                            width="15.94"
                            height="17.14"
                            viewBox="0 0 15.94 17.14"
                            focusable="false"
                          >
                            <title>This field is required.</title>
                            <path d="M15.22 10.29a1.35 1.35 0 0 1 .66.86 1.4 1.4 0 0 1-.14 1.09L15 13.47a1.35 1.35 0 0 1-.86.66 1.4 1.4 0 0 1-1.06-.13l-3-1.71v3.43a1.45 1.45 0 0 1-1.43 1.43h-1.4a1.45 1.45 0 0 1-1.43-1.43v-3.43L2.86 14a1.41 1.41 0 0 1-1.09.14 1.35 1.35 0 0 1-.87-.66l-.71-1.24a1.41 1.41 0 0 1-.14-1.09 1.34 1.34 0 0 1 .66-.86l3-1.72-3-1.72A1.35 1.35 0 0 1 .05 6a1.4 1.4 0 0 1 .14-1.1L.9 3.67A1.35 1.35 0 0 1 1.77 3a1.4 1.4 0 0 1 1.09.14l3 1.71V1.43a1.37 1.37 0 0 1 .42-1 1.37 1.37 0 0 1 1-.42h1.4a1.37 1.37 0 0 1 1 .42 1.37 1.37 0 0 1 .42 1v3.42l3-1.71A1.41 1.41 0 0 1 14.17 3a1.34 1.34 0 0 1 .87.66l.71 1.23A1.41 1.41 0 0 1 15.89 6a1.34 1.34 0 0 1-.66.86l-3 1.72z" />
                          </svg>{" "}
                          Last name
                        </label>
                      </div>
                      <div className="js-form-item form-item js-form-type-email form-item-formcta-email-address js-form-item-formcta-email-address form-float-label">
                        <input
                          aria-label="Email address"
                          className="form-cta__on-exit-email form-email required form-item__text"
                          data-drupal-selector="edit-formcta-email-address"
                          type="email"
                          id="edit-formcta-email-address--2"
                          name="formcta_email_address"
                          defaultValue=""
                          size={60}
                          maxLength={254}
                          required="required"
                          aria-required="true"
                        />
                        <label
                          htmlFor="edit-formcta-email-address--2"
                          className="option js-form-required form-required form-item__label"
                        >
                          {" "}
                          <svg
                            role="img"
                            className="icon form-item__required"
                            xmlns="http://www.w3.org/2000/svg"
                            width="15.94"
                            height="17.14"
                            viewBox="0 0 15.94 17.14"
                            focusable="false"
                          >
                            <title>This field is required.</title>
                            <path d="M15.22 10.29a1.35 1.35 0 0 1 .66.86 1.4 1.4 0 0 1-.14 1.09L15 13.47a1.35 1.35 0 0 1-.86.66 1.4 1.4 0 0 1-1.06-.13l-3-1.71v3.43a1.45 1.45 0 0 1-1.43 1.43h-1.4a1.45 1.45 0 0 1-1.43-1.43v-3.43L2.86 14a1.41 1.41 0 0 1-1.09.14 1.35 1.35 0 0 1-.87-.66l-.71-1.24a1.41 1.41 0 0 1-.14-1.09 1.34 1.34 0 0 1 .66-.86l3-1.72-3-1.72A1.35 1.35 0 0 1 .05 6a1.4 1.4 0 0 1 .14-1.1L.9 3.67A1.35 1.35 0 0 1 1.77 3a1.4 1.4 0 0 1 1.09.14l3 1.71V1.43a1.37 1.37 0 0 1 .42-1 1.37 1.37 0 0 1 1-.42h1.4a1.37 1.37 0 0 1 1 .42 1.37 1.37 0 0 1 .42 1v3.42l3-1.71A1.41 1.41 0 0 1 14.17 3a1.34 1.34 0 0 1 .87.66l.71 1.23A1.41 1.41 0 0 1 15.89 6a1.34 1.34 0 0 1-.66.86l-3 1.72z" />
                          </svg>{" "}
                          Email address
                        </label>
                      </div>
                      <input
                        data-drupal-selector="edit-interest-ids"
                        type="hidden"
                        name="interest_ids"
                        defaultValue={1804}
                        className="form-item__text"
                      />
                      <input
                        data-drupal-selector="edit-group-ids"
                        type="hidden"
                        name="group_ids"
                        className="form-item__text"
                      />
                      <input
                        className="form-cta__btn button js-form-submit form-submit btn btn--primary"
                        data-drupal-selector="edit-hab-component-newsletter-on-exit-subscription-form-submit"
                        type="submit"
                        id="edit-hab-component-newsletter-on-exit-subscription-form-submit"
                        name="op"
                        defaultValue="Subscribe"
                        data-once="drupal-ajax"
                      />
                      <input
                        autoComplete="off"
                        data-drupal-selector="form-tybphjawxp2lxktbtoc943aqwm9xte07twyx0muvvzo"
                        type="hidden"
                        name="form_build_id"
                        defaultValue="form-tybPHjAWXp2LXKtbToc943AqwM9XtE07TWYx0muVvzo"
                        className="form-item__text"
                      />
                      <input
                        data-drupal-selector="edit-hab-component-newsletter-on-exit-subscription-form"
                        type="hidden"
                        name="form_id"
                        defaultValue="hab_component_newsletter_on_exit_subscription_form"
                        className="form-item__text"
                      />
                      <div
                        className="company-textfield js-form-wrapper form-wrapper"
                        style={{ display: "none !important" }}
                      >
                        <div className="js-form-item form-item js-form-type-textfield form-item-company js-form-item-company">
                          <label
                            htmlFor="edit-company"
                            className="form-item__label"
                          >
                            Leave this field blank
                          </label>
                          <input
                            aria-label="Leave this field blank"
                            autoComplete="off"
                            data-drupal-selector="edit-company"
                            type="text"
                            id="edit-company"
                            name="company"
                            defaultValue=""
                            size={20}
                            maxLength={128}
                            className="form-text form-item__text"
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <svg
        style={{ display: "none" }}
        height={0}
        width={0}
        xmlns="http://www.w3.org/2000/svg"
      >
        <symbol id="search-icon" viewBox="0 0 36 36">
          <path d="M24.4 4.6C18.9-.9 10.1-.9 4.6 4.6s-5.5 14.3 0 19.8c5 5 12.8 5.4 18.2 1.3l.5 1.8 8 8 4.2-4.2-8-8-1.8-.5c4.1-5.4 3.6-13.2-1.3-18.2zm-3.9 15.9c-3.4 3.4-8.8 3.4-12.1 0-3.3-3.4-3.4-8.8 0-12.1 3.4-3.3 8.8-3.4 12.1 0 3.3 3.4 3.4 8.8 0 12.1z" />
        </symbol>
        <symbol id="share-icon" width={20} height={20} viewBox="0 0 20 20">
          <path d="M13.571 11.429q1.484 0 2.528 1.044t1.044 2.528-1.044 2.528-2.528 1.044-2.528-1.044-1.044-2.528q0-.134.022-.379l-4.018-2.009q-1.027.96-2.433.96-1.484 0-2.528-1.044t-1.044-2.528 1.044-2.528T3.57 6.429q1.406 0 2.433.96l4.018-2.009q-.022-.246-.022-.379 0-1.484 1.044-2.528t2.528-1.044 2.528 1.044 1.044 2.528-1.044 2.528-2.528 1.044q-1.406 0-2.433-.96L7.12 9.622q.022.246.022.379t-.022.379l4.018 2.009q1.027-.96 2.433-.96z" />
        </symbol>
        <symbol id="facebook-icon" viewBox="0 0 20 20">
          <path d="M11.4657143 19.4371429v-6.6228572h2.2257143l.4342857-2.7685714h-2.66V8.2542857c0-.76.38-1.4657143 1.5742857-1.4657143h1.1942857V4.4542857s-1.0857143-.1628571-2.1171428-.1628571c-2.1714286 0-3.5828572 1.3028571-3.5828572 3.6914285V10.1H6.1457143v2.7685714h2.3885714v6.6228572C3.9742857 18.7857143.5 14.8228571.5 10.1.5 4.8342857 4.7342857.6 10 .6s9.5 4.2342857 9.5 9.5c0 4.6685714-3.4742857 8.6314286-8.0342857 9.3371429z" />
        </symbol>
        <symbol id="twitter-icon" viewBox="0 0 19 16">
          <path d="M16.794842 4.9260745c0 4.8997135-3.713467 10.52149-10.52149 10.52149-2.114613 0-4.022922-.6189112-5.673352-1.6504298.309456.0515759.567335.0515759.876791.0515759 1.753581 0 3.300859-.5673352 4.590258-1.5988539-1.65043-.0515759-2.991404-1.0830945-3.455588-2.5787965.206304.0515759.464184.0515759.722063.0515759.309456 0 .670487-.0515759.979943-.1031519-1.702006-.3610315-2.991404-1.8567335-2.991404-3.6103151v-.051576c.515759.2578797 1.083095.4641834 1.65043.4641834-.979943-.6704871-1.65043-1.8051576-1.65043-3.0945559 0-.6704871.206304-1.3409742.515759-1.8567335C3.64298 3.7398281 6.376504 5.1839542 9.47106 5.3386819c-.051576-.2578796-.103152-.5673352-.103152-.8252149C9.367908 2.4504298 11.018338.8 13.081375.8c1.083095 0 2.011462.4641834 2.681949 1.1862464.825215-.1547278 1.65043-.4641834 2.372493-.8767908-.25788.8767908-.876791 1.5988539-1.65043 2.0630372.722063-.1031518 1.444126-.3094556 2.114613-.5673352-.515759.722063-1.13467 1.3925501-1.856734 1.9083094.051576.1031519.051576.2578797.051576.4126075z" />
        </symbol>
        <symbol id="youtube-icon" viewBox="0 0 20 21">
          <path d="M20 10.0053476s0 3.2620321-.4278075 4.8128342c-.2139037.855615-.9090909 1.4973262-1.7647059 1.7647059C16.2566845 17.0106952 10 17.0106952 10 17.0106952s-6.25668449 0-7.80748663-.4278075C1.3368984 16.368984.64171123 15.6737968.42780749 14.8181818 0 13.2673797 0 10.0053476 0 10.0053476s0-3.26203209.42780749-4.81283423c.21390374-.85561497.90909091-1.55080214 1.76470588-1.76470588C3.74331551 3 10 3 10 3s6.2566845 0 7.8074866.42780749c.855615.21390374 1.5508022.90909091 1.7647059 1.76470588C20 6.74331551 20 10.0053476 20 10.0053476zm-6.8449198 0L7.9144385 7.01069519v5.93582891l5.2406417-2.9411765z" />
        </symbol>
        <symbol id="pinterest-icon" viewBox="0 0 20 20">
          <path d="M10 19.5c-.977143 0-1.9-.1628571-2.822857-.4342857.38-.6514286.977143-1.6828572 1.194286-2.4971429.108571-.4342857.597142-2.28.597142-2.28.325715.5971429 1.194286 1.0857143 2.171429 1.0857143 2.877143 0 4.94-2.66 4.94-5.9171428 0-3.1485715-2.551429-5.4828572-5.862857-5.4828572-4.125714 0-6.297143 2.7685714-6.297143 5.7542857C3.92 11.14 4.68 12.8771429 5.82 13.42c.162857.1085714.271429.0542857.325714-.1085714.054286-.1085715.217143-.76.271429-1.0857143 0-.1085714 0-.1628572-.054286-.2714286-.38-.4885714-.705714-1.3571428-.705714-2.1714286 0-2.1171428 1.574286-4.1257142 4.288571-4.1257142 2.334286 0 3.962857 1.5742857 3.962857 3.8542857 0 2.5514285-1.302857 4.3428571-2.985714 4.3428571-.922857 0-1.628571-.76-1.411428-1.7371428.271428-1.14.76-2.3342858.76-3.1485715 0-.7057143-.38-1.3571428-1.194286-1.3571428-.977143 0-1.737143.9771428-1.737143 2.28 0 .8685714.271429 1.4114285.271429 1.4114285s-.922858 3.9628572-1.085715 4.7228572C6.308571 16.84 6.417143 17.98 6.471429 18.74 2.997143 17.4914286.5 14.0171429.5 10 .5 4.7342857 4.734286.5 10 .5s9.5 4.2342857 9.5 9.5-4.234286 9.5-9.5 9.5z" />
        </symbol>
        <symbol id="instagram-icon" viewBox="0 0 20 20">
          <path d="M19.417542 13.9276799c-.05427 1.5195742-.434164 2.8763369-1.519574 3.961747-1.08541 1.1396806-2.442173 1.4653037-3.961747 1.5195742-1.573845.108541-6.241108.108541-7.814953 0-1.519574-.0542705-2.876337-.4341641-3.961747-1.5195742S.639947 15.4472541.531406 13.9276799c-.108541-1.5738447-.108541-6.2411083 0-7.814953.05427-1.5195741.434164-2.8763368 1.519574-3.961747C3.13639 1.0655698 4.493153.6856763 6.012727.6314058c1.573845-.1085411 6.241108-.1085411 7.814953 0 1.519574.0542705 2.876337.434164 3.961747 1.5195741 1.139681 1.0854102 1.465304 2.4421729 1.519574 3.961747.162812 1.5738447.162812 6.2411083.108541 7.814953zm-1.682386-3.9074765c0-1.3567626.108541-4.3416405-.379893-5.5898622-.325623-.8140576-.976869-1.4653037-1.790927-1.7909267-1.248222-.4884346-4.233099-.3798935-5.589862-.3798935s-4.341641-.1085411-5.589862.3798935c-.814058.325623-1.465304.9768691-1.790927 1.7909267-.488435 1.2482217-.379894 4.2330996-.379894 5.5898622 0 1.3567627-.108541 4.3416406.379894 5.5898622.325623.8140576.976869 1.4653037 1.790927 1.7909267 1.248221.4884346 4.233099.3798936 5.589862.3798936s4.34164.108541 5.589862-.3798936c.814058-.325623 1.465304-.9768691 1.790927-1.7909267.542705-1.2482216.379893-4.2330995.379893-5.5898622zm-2.876336 0c0 2.7135254-2.170821 4.8843456-4.884346 4.8843456-2.713525 0-4.884346-2.1708202-4.884346-4.8843456 0-2.7135253 2.170821-4.8843456 4.884346-4.8843456 2.713525 0 4.884346 2.1708203 4.884346 4.8843456zm-1.736657 0c0-1.7366562-1.411033-3.1476894-3.147689-3.1476894-1.736656 0-3.147689 1.4110332-3.147689 3.1476894 0 1.7366562 1.411033 3.1476894 3.147689 3.1476894 1.736656 0 3.147689-1.4110332 3.147689-3.1476894zm1.899468-3.9074765c-.651246 0-1.139681-.4884345-1.139681-1.1396806 0-.6512461.488435-1.1396806 1.139681-1.1396806s1.139681.4884345 1.139681 1.1396806c0 .5969756-.488435 1.1396806-1.139681 1.1396806z" />
        </symbol>
      </svg>
      <footer role="contentinfo" className="footer">
        <div className="footer__over">
          <div className="footer__search">
            <div
              className="views-exposed-form"
              data-drupal-selector="views-exposed-form-search-page"
              id="block-exposedformsearchpage"
            >
              <form
                action="/search"
                method="get"
                id="views-exposed-form-search-page"
                acceptCharset="UTF-8"
                className="site-search"
              >
                <div className="js-form-item js-form-type-textfield js-form-item-search site-search__group">
                  <label htmlFor="edit-search" className="visually-hidden">
                    Fulltext search
                  </label>
                  <input
                    placeholder="Looking for something?"
                    className="site-search__input form-text"
                    data-drupal-selector="edit-search"
                    type="text"
                    id="edit-search"
                    name="search"
                    defaultValue=""
                    size={30}
                    maxLength={128}
                  />
                </div>
                <div
                  data-drupal-selector="edit-actions"
                  className="form-actions js-form-wrapper form-wrapper"
                  id="edit-actions"
                >
                  <button
                    data-drupal-selector="edit-submit-search"
                    type="submit"
                    id="edit-submit-search"
                    className="button js-form-submit form-submit btn site-search__btn"
                  >
                    {" "}
                    <svg
                      aria-hidden="true"
                      role="img"
                      className="icon site-search__icon"
                      width={36}
                      height={36}
                    >
                      <use xlinkHref="#search-icon" />
                    </svg>
                    <span className="visually-hidden">Search</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="footer__social footer-hide-small">
            <div className="social-bar  ">
              <button
                data-toggle-class="is-visible"
                data-target=".js-social-bar"
                className="btn social-bar__btn"
                data-listener="true"
              >
                {" "}
                <svg
                  aria-hidden="true"
                  role="img"
                  className="social-bar__share"
                  width={20}
                  height={20}
                >
                  <use xlinkHref="#share-icon" />
                </svg>
              </button>
              <div className="social-bar__container">
                <div className="social-bar__wrapper js-social-bar">
                  <ul className="social-bar__list">
                    <li className="social-bar__item">
                      <a
                        className="social-bar__link social-bar__link--facebook"
                        href="https://www.facebook.com/habitat/"
                        target="_blank"
                        title="Facebook"
                        aria-label="Facebook"
                      >
                        <svg
                          aria-hidden="true"
                          role="img"
                          className="social-bar__icon"
                          width={20}
                          height={20}
                        >
                          <use xlinkHref="#facebook-icon" />
                        </svg>
                      </a>
                    </li>
                    <li className="social-bar__item">
                      <a
                        className="social-bar__link social-bar__link--twitter"
                        href="https://twitter.com/habitat_org"
                        target="_blank"
                        title="Twitter"
                        aria-label="Twitter"
                      >
                        <svg
                          aria-hidden="true"
                          role="img"
                          className="social-bar__icon"
                          width={19}
                          height={16}
                        >
                          <use xlinkHref="#twitter-icon" />
                        </svg>
                      </a>
                    </li>
                    <li className="social-bar__item">
                      <a
                        className="social-bar__link social-bar__link--youtube"
                        href="https://www.youtube.com/user/HabitatForHumanity"
                        target="_blank"
                        title="Youtube"
                        aria-label="Youtube"
                      >
                        <svg
                          aria-hidden="true"
                          role="img"
                          className="social-bar__icon"
                          width={20}
                          height={20}
                        >
                          <use xlinkHref="#youtube-icon" />
                        </svg>
                      </a>
                    </li>
                    <li className="social-bar__item">
                      <a
                        className="social-bar__link social-bar__link--pinterest"
                        href="https://www.pinterest.com/habitathumanity"
                        target="_blank"
                        title="Pinterest"
                        aria-label="Pinterest"
                      >
                        <svg
                          aria-hidden="true"
                          role="img"
                          className="social-bar__icon"
                          width={20}
                          height={20}
                        >
                          <use xlinkHref="#pinterest-icon" />
                        </svg>
                      </a>
                    </li>
                    <li className="social-bar__item">
                      <a
                        className="social-bar__link social-bar__link--instagram"
                        href="https://www.instagram.com/habitatforhumanity/"
                        target="_blank"
                        title="Instagram"
                        aria-label="Instagram"
                      >
                        <svg
                          aria-hidden="true"
                          role="img"
                          className="social-bar__icon"
                          width={20}
                          height={20}
                        >
                          <use xlinkHref="#instagram-icon" />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="footer__donate">
            <a
              className="btn btn--donate footer__btn"
              href="https://secure.habitat.org/site/Donation2?df_id=4973&keyword=button-footer-menu-single"
            >
              Donate
            </a>
          </div>
          <div className="footer__copyright footer-show-small">
            <div className="footer__copyright-content">
              <p>© 2024 Habitat for Humanity® International.</p>
              <p>
                All rights reserved. “Habitat for Humanity®” is a registered
                service mark owned by Habitat for Humanity International.
                Habitat® is a service mark of Habitat for Humanity
                International.
              </p>
              <p>
                Habitat for Humanity® International is a tax-exempt 501(C)(3)
                nonprofit organization. Your gift is tax-deductible as allowed
                by law.
              </p>
            </div>
          </div>
        </div>
        <div className="footer__container">
          <div className="footer__content l-center">
            <div className="footer__logo">
              <div className="site-logo site-logo--footer">
                <a href="/" rel="home" className="site-logo__link active">
                  <svg
                    className="site-logo__icon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 120 40"
                    width={120}
                    height={40}
                  >
                    <title>Logo</title>
                    <path d="M14.9,17.06a2.14,2.14,0,1,1,2.29,2,2.14,2.14,0,0,1-2.29-2h0Z" />
                    <path d="M40,17.06a2.14,2.14,0,1,0-2.29,2,2.14,2.14,0,0,0,2.29-2h0Z" />
                    <path d="M47.06,20.41c-0.25-.93-1.53-1.07-2.66-0.78a22.2,22.2,0,0,1-6.75.89c-2-.14-3.91-1.79-5.12-2.92,1.2-1.38,2.74-2.86,3.09-3.27a1.57,1.57,0,0,0,.17-2c-0.43-.43-1.19-0.17-2,0.34s-3.66,3.43-6.42,3.43-5.75-2.92-6.52-3.43a2,2,0,0,0-2.3,0c-0.43.43,0,1,.51,1.62,0.36,0.42,2,2,3.17,3.36-1.21,1.12-3.1,2.69-5,2.83a22.19,22.19,0,0,1-6.75-.89c-1.13-.29-2.41-0.15-2.66.78a1.72,1.72,0,0,0,1,1.65c0.66,0.43,4.07,1.09,5,2.56s1.11,12.82,2,13.2a3.36,3.36,0,0,0,2.41,0c0.87-.44,2.33-12.82,3.06-14.41a19.35,19.35,0,0,1,2.35-3.3c0.79,3.7,1.65,17.48,2.48,17.76a4.44,4.44,0,0,0,2.38,0c0.82-.35,1.72-14.5,2.52-17.93a20.35,20.35,0,0,1,2.49,3.46c0.74,1.59,2.2,14,3.06,14.41a3.37,3.37,0,0,0,2.41,0c0.89-.38,1-11.73,2-13.2s4.37-2.13,5-2.56a1.72,1.72,0,0,0,1-1.65h0Z" />
                    <path d="M25.31,12.52a2.14,2.14,0,1,1,2.14,2.14,2.14,2.14,0,0,1-2.14-2.14h0Z" />
                    <path d="M47.49,12.67c1,1.65-1.14,2.27-2.8,1.89-1.39-.32-15.06-7.62-17.11-7.81s-14.33,7.37-15.69,8.1a5.53,5.53,0,0,1-5.59,0C5.7,14.53,1,12.06,0,11.37c1-1,15.23-9.49,16.89-10.31,1.9-1,3-1.46,5.13-.67,1.45,0.54,25,11.6,25.47,12.28h0Z" />
                    <path d="M5.39,23.27a28.24,28.24,0,0,1,4,1.67c2.39,1.23,2.52,2.46,2.79,4.45s0.54,6.08.58,7.58a53.62,53.62,0,0,1-5.86-4.52c-0.72-.63-1.54-1.08-1.53-2.05,0-.37-0.17-6.22,0-7.14h0Z" />
                    <path d="M117.56,29.24A1.79,1.79,0,1,1,115.75,31a1.79,1.79,0,0,1,1.81-1.79h0Zm0,3.31A1.52,1.52,0,1,0,116.08,31a1.47,1.47,0,0,0,1.48,1.53h0Zm-0.39-.49h-0.3V30h0.8a0.59,0.59,0,0,1,.73.59,0.55,0.55,0,0,1-.55.58l0.6,0.92h-0.33l-0.57-.91h-0.39v0.91h0Zm0-1.16h0.49c0.33,0,.43-0.12.43-0.35a0.32,0.32,0,0,0-.37-0.32h-0.56V30.9h0Z" />
                    <path d="M57,11.65c-0.09,1.05-.11,2.27-0.11,3.58V17.7c0.47,0,.94,0,1.63,0s1.16,0,1.63,0V15.23c0-1.31,0-2.53-.11-3.58h4.06a75.66,75.66,0,0,0-.21,7.66A75.67,75.67,0,0,0,64.09,27H60c0.09-1.05.11-2.28,0.11-3.58V20.25c-0.47,0-.94,0-1.63,0s-1.16,0-1.63,0v3.13c0,1.31,0,2.53.11,3.58H52.93a75.42,75.42,0,0,0,.21-7.66,75.41,75.41,0,0,0-.21-7.66H57Z" />
                    <path d="M66,16.07a20.71,20.71,0,0,1,2.25-.17c4.44,0,5.79,1.74,5.79,4.61v2.68A10.26,10.26,0,0,0,74.56,27H71.15a2.13,2.13,0,0,1-.37-0.67,4,4,0,0,1-2.4.84,3.22,3.22,0,0,1-3.43-3.24c0-2,1.57-3.31,3.61-4l1.78-.58A1.39,1.39,0,0,0,68.81,18,5.27,5.27,0,0,0,66,19.07v-3h0Zm4.66,5.32a2.49,2.49,0,0,0-2.19,2.25A1.21,1.21,0,0,0,69.58,25a1.42,1.42,0,0,0,1-.47V21.39h0Z" />
                    <path d="M79.34,11.65V16.5a4.24,4.24,0,0,1,2.08-.6c2,0,3.95,1.5,3.95,5.41,0,3-1.65,5.92-4.7,5.92a4.45,4.45,0,0,1-2.77-1.07l-1.2,1-1-.62a31.83,31.83,0,0,0,.19-4.38V16c0-.79,0-1.67-0.22-4.38h3.69Zm0,12.32a0.93,0.93,0,0,0,.92,1.12c0.88,0,1.5-.9,1.5-3.45,0-1.82-.47-3.39-1.55-3.39a0.81,0.81,0,0,0-.88.88V24h0Z" />
                    <path d="M88.43,11.5a1.93,1.93,0,1,1-1.93,1.93,1.92,1.92,0,0,1,1.93-1.93h0Zm1.78,4.66c0,1.11,0,2.75,0,5.06A43.3,43.3,0,0,0,90.36,27H86.49a31.92,31.92,0,0,0,.19-4.38V20.53a31.9,31.9,0,0,0-.19-4.38h3.71Z" />
                    <path d="M96.13,12.87c0,0.66-.07,1.93-0.07,3.28h1.61v2.06H96.07v5.41A1.12,1.12,0,0,0,97.25,25a3.63,3.63,0,0,0,.45,0v1.93a6.81,6.81,0,0,1-2.17.32,2.88,2.88,0,0,1-2.32-1,4,4,0,0,1-.62-2.53V18.21H91.34V16.15h1.24c0-1.35,0-2.62-.07-3.28h3.61Z" />
                    <path d="M99.78,16.07A20.75,20.75,0,0,1,102,15.9c4.44,0,5.79,1.74,5.79,4.61v2.68a10.27,10.27,0,0,0,.56,3.78H105a2.06,2.06,0,0,1-.36-0.67,4,4,0,0,1-2.4.84,3.22,3.22,0,0,1-3.43-3.24c0-2,1.57-3.31,3.6-4l1.78-.58A1.39,1.39,0,0,0,102.64,18a5.28,5.28,0,0,0-2.86,1.12v-3h0Zm4.66,5.32a2.49,2.49,0,0,0-2.19,2.25A1.21,1.21,0,0,0,103.41,25a1.42,1.42,0,0,0,1-.47V21.39h0Z" />
                    <path d="M113.64,12.87c0,0.66-.06,1.93-0.06,3.28h1.61v2.06h-1.61v5.41A1.12,1.12,0,0,0,114.76,25a3.63,3.63,0,0,0,.45,0v1.93a6.81,6.81,0,0,1-2.17.32,2.88,2.88,0,0,1-2.32-1,4,4,0,0,1-.62-2.53V18.21h-1.25V16.15h1.25c0-1.35,0-2.62-.07-3.28h3.61Z" />
                    <path d="M56.42,30.7A0.78,0.78,0,0,0,56,30.58a0.71,0.71,0,0,0-.72.77,1.7,1.7,0,0,0,.12.58h0.87V33H55.35v2.37a17.39,17.39,0,0,0,.1,2.37H53.36a17.28,17.28,0,0,0,.1-2.37V33H52.83V31.93h0.64V31.48a1.8,1.8,0,0,1,.66-1.6,2.49,2.49,0,0,1,1.56-.5,2.38,2.38,0,0,1,.73.11V30.7h0Z" />
                    <path d="M61.79,34.86a2.74,2.74,0,1,1-5.44,0,2.74,2.74,0,1,1,5.44,0h0Zm-3.37,0c0,1.41.3,1.91,0.65,1.91s0.65-.5.65-1.91S59.42,33,59.07,33s-0.65.5-.65,1.91h0Z" />
                    <path d="M64.24,31.93a4.08,4.08,0,0,1,.16.78,1.91,1.91,0,0,1,1.48-.92,0.67,0.67,0,0,1,.26,0v1.55a1.57,1.57,0,0,0-.35,0c-0.88,0-1.27.81-1.27,2.09a17.31,17.31,0,0,0,.1,2.37H62.46a17.19,17.19,0,0,0,.11-2.37V34.3a9.27,9.27,0,0,0-.2-2.37h1.87Z" />
                    <path d="M72.33,29.49c0,0.57-.06,1.23-0.06,1.94v1.34l0.88,0,0.88,0V31.43c0-.71,0-1.37-0.06-1.94h2.2a41,41,0,0,0-.12,4.15,41,41,0,0,0,.12,4.15H74c0-.57.06-1.23,0.06-1.94v-1.7c-0.25,0-.51,0-0.88,0s-0.63,0-.88,0v1.7c0,0.71,0,1.37.06,1.94h-2.2a41.17,41.17,0,0,0,.12-4.15,41.16,41.16,0,0,0-.12-4.15h2.2Z" />
                    <path d="M80.42,37.79a2.63,2.63,0,0,1-.17-0.52,2,2,0,0,1-1.48.66,1.64,1.64,0,0,1-1.64-1.84V34.3A17,17,0,0,0,77,31.93h2v3.89a0.57,0.57,0,1,0,1.12.12V34.3a17.34,17.34,0,0,0-.1-2.37h2.09A17.18,17.18,0,0,0,82,34.3v1.12a17.19,17.19,0,0,0,.11,2.37h-1.7Z" />
                    <path d="M84.84,31.93a2.89,2.89,0,0,1,.18.52,2.28,2.28,0,0,1,1.53-.66,1.57,1.57,0,0,1,1.3.74,2.35,2.35,0,0,1,1.64-.74c1.14,0,1.57.8,1.57,2v1.67a17.51,17.51,0,0,0,.1,2.37H89.07a17.51,17.51,0,0,0,.1-2.37V33.8c0-.41-0.12-0.71-0.48-0.71a0.63,0.63,0,0,0-.62.71v1.62a17.19,17.19,0,0,0,.11,2.37H86.1a17.19,17.19,0,0,0,.11-2.37V33.78c0-.38-0.12-0.69-0.48-0.69a0.62,0.62,0,0,0-.62.62v1.71a17.27,17.27,0,0,0,.1,2.37H83.12a17.35,17.35,0,0,0,.1-2.37V34.3a17.34,17.34,0,0,0-.1-2.37h1.72Z" />
                    <path d="M92.29,31.88a11.54,11.54,0,0,1,1.22-.09c2.41,0,3.14.94,3.14,2.5v1.45a5.57,5.57,0,0,0,.3,2H95.11a1.09,1.09,0,0,1-.2-0.36,2.16,2.16,0,0,1-1.3.45,1.75,1.75,0,0,1-1.86-1.76,2.41,2.41,0,0,1,2-2.15l1-.31a0.75,0.75,0,0,0-.83-0.76,2.86,2.86,0,0,0-1.55.61V31.88h0Zm2.52,2.88A1.35,1.35,0,0,0,93.63,36a0.66,0.66,0,0,0,.63.72,0.76,0.76,0,0,0,.56-0.26V34.77h0Z" />
                    <path d="M99.19,31.93a2.8,2.8,0,0,1,.17.52,2,2,0,0,1,1.48-.66,1.64,1.64,0,0,1,1.64,1.84v1.79a17.2,17.2,0,0,0,.11,2.37h-2.09a17.19,17.19,0,0,0,.11-2.37v-1.6a0.54,0.54,0,0,0-.5-0.65,0.59,0.59,0,0,0-.62.56v1.7a17.52,17.52,0,0,0,.1,2.37H97.49a17.5,17.5,0,0,0,.1-2.37V34.3a17.5,17.5,0,0,0-.1-2.37h1.7Z" />
                    <path d="M104.31,29.41a1,1,0,1,1-1,1,1,1,0,0,1,1-1h0Zm1,2.52c0,0.6,0,1.49,0,2.74a23.42,23.42,0,0,0,.1,3.12h-2.09a17.27,17.27,0,0,0,.1-2.37V34.3a17.26,17.26,0,0,0-.1-2.37h2Z" />
                    <path d="M108.59,30.15c0,0.36,0,1,0,1.78h0.87V33h-0.87V36a0.61,0.61,0,0,0,.64.74h0.24v1a3.7,3.7,0,0,1-1.18.17,1.56,1.56,0,0,1-1.25-.56,2.17,2.17,0,0,1-.34-1.37V33H106V31.93h0.67c0-.73,0-1.42,0-1.78h2Z" />
                    <path d="M112,31.93a33.43,33.43,0,0,0,.83,3.31h0a27.4,27.4,0,0,0,.68-3.31h1.66a40.54,40.54,0,0,1-2,6.35A2.61,2.61,0,0,1,110.63,40a2.22,2.22,0,0,1-.56-0.06V38.45a1.41,1.41,0,0,0,.65.17,1,1,0,0,0,1-.93,5.32,5.32,0,0,0-.51-1.59A26.18,26.18,0,0,1,110,31.93h2Z" />
                  </svg>
                </a>
              </div>
            </div>
            <div className="footer__social footer-show-small">
              <div className="social-bar social-bar--footer social-bar--dark ">
                <button
                  data-toggle-class="is-visible"
                  data-target=".js-social-bar"
                  className="btn social-bar__btn"
                  data-listener="true"
                >
                  {" "}
                  <svg
                    aria-hidden="true"
                    role="img"
                    className="social-bar__share"
                    width={20}
                    height={20}
                  >
                    <use xlinkHref="#share-icon" />
                  </svg>
                </button>
                <div className="social-bar__container">
                  <div className="social-bar__wrapper js-social-bar">
                    <ul className="social-bar__list">
                      <li className="social-bar__item">
                        <a
                          className="social-bar__link social-bar__link--facebook"
                          href="https://www.facebook.com/habitat/"
                          target="_blank"
                          title="Facebook"
                          aria-label="Facebook"
                        >
                          <svg
                            aria-hidden="true"
                            role="img"
                            className="social-bar__icon"
                            width={20}
                            height={20}
                          >
                            <use xlinkHref="#facebook-icon" />
                          </svg>
                        </a>
                      </li>
                      <li className="social-bar__item">
                        <a
                          className="social-bar__link social-bar__link--twitter"
                          href="https://twitter.com/habitat_org"
                          target="_blank"
                          title="Twitter"
                          aria-label="Twitter"
                        >
                          <svg
                            aria-hidden="true"
                            role="img"
                            className="social-bar__icon"
                            width={19}
                            height={16}
                          >
                            <use xlinkHref="#twitter-icon" />
                          </svg>
                        </a>
                      </li>
                      <li className="social-bar__item">
                        <a
                          className="social-bar__link social-bar__link--youtube"
                          href="https://www.youtube.com/user/HabitatForHumanity"
                          target="_blank"
                          title="Youtube"
                          aria-label="Youtube"
                        >
                          <svg
                            aria-hidden="true"
                            role="img"
                            className="social-bar__icon"
                            width={20}
                            height={20}
                          >
                            <use xlinkHref="#youtube-icon" />
                          </svg>
                        </a>
                      </li>
                      <li className="social-bar__item">
                        <a
                          className="social-bar__link social-bar__link--pinterest"
                          href="https://www.pinterest.com/habitathumanity"
                          target="_blank"
                          title="Pinterest"
                          aria-label="Pinterest"
                        >
                          <svg
                            aria-hidden="true"
                            role="img"
                            className="social-bar__icon"
                            width={20}
                            height={20}
                          >
                            <use xlinkHref="#pinterest-icon" />
                          </svg>
                        </a>
                      </li>
                      <li className="social-bar__item">
                        <a
                          className="social-bar__link social-bar__link--instagram"
                          href="https://www.instagram.com/habitatforhumanity/"
                          target="_blank"
                          title="Instagram"
                          aria-label="Instagram"
                        >
                          <svg
                            aria-hidden="true"
                            role="img"
                            className="social-bar__icon"
                            width={20}
                            height={20}
                          >
                            <use xlinkHref="#instagram-icon" />
                          </svg>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer__menu">
              <nav className="footer-menu">
                <ul className="footer-menu__list">
                  <li className="footer-menu__item">
                    <a className="footer-menu__link" href="/volunteer">
                      Volunteer
                    </a>
                  </li>
                  <li className="footer-menu__item">
                    <a className="footer-menu__link" href="/about/advocacy">
                      Advocate
                    </a>
                  </li>
                  <li className="footer-menu__item">
                    <a
                      className="footer-menu__link"
                      href="https://www.habitat.org/support"
                    >
                      Support
                    </a>
                  </li>
                  <li className="footer-menu__item">
                    <a className="footer-menu__link" href="/shop">
                      Shop
                    </a>
                  </li>
                  <li className="footer-menu__item">
                    <a className="footer-menu__link" href="/our-work">
                      Our work
                    </a>
                  </li>
                  <li className="footer-menu__item">
                    <a className="footer-menu__link" href="/housing-help">
                      Housing help
                    </a>
                  </li>
                  <li className="footer-menu__item">
                    <a className="footer-menu__link" href="/about">
                      About
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="footer__submenu">
              <nav className="footer-submenu">
                <ul className="footer-submenu__list">
                  <li className="footer-submenu__item">
                    <a
                      className="footer-submenu__link"
                      href="https://www.habitat.org/support"
                    >
                      Support
                    </a>
                    <ul className="footer-submenu__sub">
                      <li className="footer-submenu__subitem">
                        <a
                          className="footer-submenu__link footer-submenu__sublink"
                          href="https://secure.habitat.org/site/Donation2?df_id=4973&keyword=footer-menu-single-text"
                        >
                          Donate one time
                        </a>
                      </li>
                      <li className="footer-submenu__subitem">
                        <a
                          className="footer-submenu__link footer-submenu__sublink"
                          href="https://secure.habitat.org/site/Donation2?df_id=4976&keyword=footer-menu-monthly-text"
                        >
                          Donate monthly
                        </a>
                      </li>
                      <li className="footer-submenu__subitem">
                        <a
                          className="footer-submenu__link footer-submenu__sublink"
                          href="/support/corporate-giving"
                        >
                          Partnerships
                        </a>
                      </li>
                      <li className="footer-submenu__subitem">
                        <a
                          className="footer-submenu__link footer-submenu__sublink"
                          href="/restores/donate-goods"
                        >
                          Donate goods
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li className="footer-submenu__item">
                    <a className="footer-submenu__link" href="/contact">
                      Contact Us
                    </a>
                    <ul className="footer-submenu__sub">
                      <li className="footer-submenu__subitem">
                        <a
                          className="footer-submenu__link footer-submenu__sublink"
                          href="/about/newsroom"
                        >
                          Newsroom
                        </a>
                      </li>
                      <li className="footer-submenu__subitem">
                        <a
                          className="footer-submenu__link footer-submenu__sublink"
                          href="/about/careers"
                        >
                          Careers
                        </a>
                      </li>
                      <li className="footer-submenu__subitem">
                        <a
                          className="footer-submenu__link footer-submenu__sublink"
                          href="/privacy-policy"
                        >
                          Privacy policy
                        </a>
                      </li>
                      <li className="footer-submenu__subitem">
                        <a
                          className="footer-submenu__link footer-submenu__sublink"
                          href="/terms-of-service"
                        >
                          Terms of service
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="footer__copyright footer-hide-small">
              <div className="footer__copyright-content">
                <p>© 2024 Habitat for Humanity® International.</p>
                <p>
                  All rights reserved. “Habitat for Humanity®” is a registered
                  service mark owned by Habitat for Humanity International.
                  Habitat® is a service mark of Habitat for Humanity
                  International.
                </p>
                <p>
                  Habitat for Humanity® International is a tax-exempt 501(C)(3)
                  nonprofit organization. Your gift is tax-deductible as allowed
                  by law.
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  <noscript>
    &lt;img src="https://bat.bing.com/action/0?ti=5439085&amp;Ver=2" height="0"
    width="0" style="display:none; visibility: hidden;" /&gt;
  </noscript>
  <div
    id="drupal-live-announce"
    className="visually-hidden"
    aria-live="polite"
    aria-busy="false"
  />
  <iframe
    height={0}
    width={0}
    style={{ display: "none", visibility: "hidden" }}
    src="https://4445139.fls.doubleclick.net/activityi;src=4445139;type=general0;cat=allpa0;ord=989518585868;auiddc=174736034.1705352992;u1=www.habitat.org%2F;u3=www.google.com%2F;u4=undefined;u9=%22NonEvent%22;u2=utm_source%3Dundefined%2Cutm_campaign%3Dundefined%2Cutm_medium%3Dundefined;ps=1;pcor=1313534463;gtm=45He41a0v76136950;gcd=11l1l1l1l1;dma=0;uaa=arm;uab=64;uafvl=Not_A%2520Brand%3B8.0.0.0%7CChromium%3B120.0.6099.216%7CGoogle%2520Chrome%3B120.0.6099.216;uamb=0;uam=;uap=macOS;uapv=12.5.1;uaw=0;epver=2;~oref=https%3A%2F%2Fwww.habitat.org%2F?"
  />
  <iframe
    allow="join-ad-interest-group"
    data-tagging-id="DC-4445139/general0/allpa0+standard"
    data-load-time={1705352991513}
    height={0}
    width={0}
    style={{ display: "none", visibility: "hidden" }}
    src="https://td.doubleclick.net/td/fls/rul/activityi;fledge=1;src=4445139;type=general0;cat=allpa0;ord=989518585868;auiddc=174736034.1705352992;u1=www.habitat.org%2F;u3=www.google.com%2F;u4=undefined;u9=%22NonEvent%22;u2=utm_source%3Dundefined%2Cutm_campaign%3Dundefined%2Cutm_medium%3Dundefined;ps=1;pcor=1313534463;gtm=45He41a0v76136950;gcd=11l1l1l1l1;dma=0;uaa=arm;uab=64;uafvl=Not_A%2520Brand%3B8.0.0.0%7CChromium%3B120.0.6099.216%7CGoogle%2520Chrome%3B120.0.6099.216;uamb=0;uam=;uap=macOS;uapv=12.5.1;uaw=0;epver=2;~oref=https%3A%2F%2Fwww.habitat.org%2F?"
  />
  <iframe
    height={0}
    width={0}
    style={{ display: "none", visibility: "hidden" }}
    src="https://4445139.fls.doubleclick.net/activityi;src=4445139;type=general0;cat=allpa0;ord=1;num=9875801825983;auiddc=174736034.1705352992;u1=www.habitat.org%2F;u3=www.google.com%2F;u4=undefined;u9=%22NonEvent%22;u2=utm_source%3Dundefined%2Cutm_campaign%3Dundefined%2Cutm_medium%3Dundefined;ps=1;pcor=1013943105;gtm=45He41a0v76136950;gcd=11l1l1l1l1;dma=0;uaa=arm;uab=64;uafvl=Not_A%2520Brand%3B8.0.0.0%7CChromium%3B120.0.6099.216%7CGoogle%2520Chrome%3B120.0.6099.216;uamb=0;uam=;uap=macOS;uapv=12.5.1;uaw=0;epver=2;~oref=https%3A%2F%2Fwww.habitat.org%2F?"
  />
  <iframe
    allow="join-ad-interest-group"
    data-tagging-id="DC-4445139/general0/allpa0+unique"
    data-load-time={1705352991517}
    height={0}
    width={0}
    style={{ display: "none", visibility: "hidden" }}
    src="https://td.doubleclick.net/td/fls/rul/activityi;fledge=1;src=4445139;type=general0;cat=allpa0;ord=1;num=9875801825983;auiddc=174736034.1705352992;u1=www.habitat.org%2F;u3=www.google.com%2F;u4=undefined;u9=%22NonEvent%22;u2=utm_source%3Dundefined%2Cutm_campaign%3Dundefined%2Cutm_medium%3Dundefined;ps=1;pcor=1013943105;gtm=45He41a0v76136950;gcd=11l1l1l1l1;dma=0;uaa=arm;uab=64;uafvl=Not_A%2520Brand%3B8.0.0.0%7CChromium%3B120.0.6099.216%7CGoogle%2520Chrome%3B120.0.6099.216;uamb=0;uam=;uap=macOS;uapv=12.5.1;uaw=0;epver=2;~oref=https%3A%2F%2Fwww.habitat.org%2F?"
  />
  <iframe
    height={0}
    width={0}
    style={{ display: "none", visibility: "hidden" }}
    src="https://4445139.fls.doubleclick.net/activityi;src=4445139;type=Homep0;cat=homep00;ord=4662827019889;auiddc=174736034.1705352992;u1=www.habitat.org%2F;u9=%22NonEvent%22;u2=utm_source%3Dundefined%2Cutm_campaign%3Dundefined%2Cutm_medium%3Dundefined;ps=1;pcor=1495374807;gtm=45He41a0v76136950;gcd=11l1l1l1l1;dma=0;uaa=arm;uab=64;uafvl=Not_A%2520Brand%3B8.0.0.0%7CChromium%3B120.0.6099.216%7CGoogle%2520Chrome%3B120.0.6099.216;uamb=0;uam=;uap=macOS;uapv=12.5.1;uaw=0;epver=2;~oref=https%3A%2F%2Fwww.habitat.org%2F?"
  />
  <iframe
    allow="join-ad-interest-group"
    data-tagging-id="DC-4445139/Homep0/homep00+standard"
    data-load-time={1705352991520}
    height={0}
    width={0}
    style={{ display: "none", visibility: "hidden" }}
    src="https://td.doubleclick.net/td/fls/rul/activityi;fledge=1;src=4445139;type=Homep0;cat=homep00;ord=4662827019889;auiddc=174736034.1705352992;u1=www.habitat.org%2F;u9=%22NonEvent%22;u2=utm_source%3Dundefined%2Cutm_campaign%3Dundefined%2Cutm_medium%3Dundefined;ps=1;pcor=1495374807;gtm=45He41a0v76136950;gcd=11l1l1l1l1;dma=0;uaa=arm;uab=64;uafvl=Not_A%2520Brand%3B8.0.0.0%7CChromium%3B120.0.6099.216%7CGoogle%2520Chrome%3B120.0.6099.216;uamb=0;uam=;uap=macOS;uapv=12.5.1;uaw=0;epver=2;~oref=https%3A%2F%2Fwww.habitat.org%2F?"
  />
  <div
    id="batBeacon443991478149"
    style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
  >
    <img
      id="batBeacon359677665625"
      width={0}
      height={0}
      alt=""
      src="https://bat.bing.com/action/0?ti=5439085&Ver=2&mid=7951ba81-c34c-4c62-88be-afd32dab9bc0&sid=6c36c8d0b3ea11ee8de8e9768bfa554e&vid=6c36e000b3ea11ee8da1fda68624e407&vids=1&msclkid=N&pi=918639831&lg=en-US&sw=1512&sh=982&sc=30&tl=Habitat%20for%20Humanity&p=https%3A%2F%2Fwww.habitat.org%2F&r=https%3A%2F%2Fwww.google.com%2F&lt=358&evt=pageLoad&sv=1&rn=983358"
      style={{ width: 0, height: 0, display: "none", visibility: "hidden" }}
    />
  </div>
  <div style={{ display: "none", visibility: "hidden" }}></div>
  <div />
  <iframe
    src="https://s.amazon-adsystem.com/iu3?pid=dfde698f-07d1-42ad-8ffa-d483b9d1654f&event=PageView&ts=1705352991525"
    id="tag_fire_dfde698f-07d1-42ad-8ffa-d483b9d1654f_PageView"
    style={{ display: "none" }}
  />
  <div id="fb-root" className=" fb_reset">
    <div style={{ position: "absolute", top: "-10000px", width: 0, height: 0 }}>
      <div />
    </div>
  </div>
  <iframe
    id="universal_pixel_ddx2kjy"
    height={0}
    width={0}
    style={{ display: "none" }}
    src="https://insight.adsrvr.org/track/up?adv=f9aplkw&ref=https%3A%2F%2Fwww.habitat.org%2F&upid=ddx2kjy&upv=1.1.0"
    title="TTD Universal Pixel"
  />
</>


    
  );
}
